import { C as e, E as t, S as n, T as r, _ as i, a, b as o, c as s, d as c, f as l, g as u, h as d, i as f, l as p, m, o as h, p as g, r as _, s as v, t as y, u as b, v as x, w as S, x as ee, y as te } from "./MarkdownRenderer-kStoDRNE.mjs";
import { Fragment as C, Transition as w, computed as T, createBlock as E, createCommentVNode as D, createElementBlock as O, createElementVNode as k, createSlots as ne, createTextVNode as A, createVNode as j, defineAsyncComponent as re, defineComponent as M, guardReactiveProps as ie, markRaw as N, mergeProps as P, normalizeClass as F, normalizeProps as ae, normalizeStyle as oe, onBeforeUnmount as se, onMounted as I, onUnmounted as ce, openBlock as L, ref as R, renderList as z, renderSlot as B, resolveComponent as V, resolveDynamicComponent as le, toDisplayString as H, vShow as ue, watch as U, withCtx as W, withDirectives as de, withKeys as G, withModifiers as K } from "vue";
import q from "moment";
import { FieldType as fe, Status as J, displayableDataToViewData as pe, emptyTagFilter as me, hasActiveFilter as he, log as Y, toCourseElo as ge } from "@vue-skuilder/common";
import { GuestUsername as _e, SessionController as ve, getCardHistoryID as ye, getDataLayer as X, getStudySource as be } from "@vue-skuilder/db";
import { defineStore as xe, setActivePinia as Se } from "pinia";
import { useRoute as Ce, useRouter as we } from "vue-router";
import { VueTagsInput as Te } from "@vojtechlanka/vue-tags-input";
//#region src/components/HeatMap.vue?vue&type=script&lang.ts
var Ee = M({
	name: "HeatMap",
	props: {
		activityRecords: {
			type: Array,
			default: () => []
		},
		activityRecordsGetter: {
			type: Function,
			default: null
		},
		inactiveColor: {
			type: Object,
			default: () => ({
				h: 0,
				s: 0,
				l: .9
			})
		},
		activeColor: {
			type: Object,
			default: () => ({
				h: 155,
				s: 1,
				l: .5
			})
		},
		cellSize: {
			type: Number,
			default: 12
		},
		cellMargin: {
			type: Number,
			default: 3
		},
		enableSeasonalColors: {
			type: Boolean,
			default: !0
		}
	},
	data() {
		return {
			isLoading: !1,
			localActivityRecords: [],
			heatmapData: {},
			weeks: [],
			tooltipData: null,
			tooltipStyle: {},
			maxInRange: 0
		};
	},
	computed: {
		width() {
			return 53 * (this.cellSize + this.cellMargin);
		},
		height() {
			return 7 * (this.cellSize + this.cellMargin);
		},
		effectiveActivityRecords() {
			let e = Array.isArray(this.localActivityRecords) && this.localActivityRecords.length > 0, t = e ? this.localActivityRecords : this.activityRecords || [];
			return console.log("Using effectiveActivityRecords, count:", t.length, "source:", e ? "local" : "prop"), t;
		}
	},
	watch: { activityRecords: {
		handler() {
			this.processRecords(), this.createWeeksData();
		},
		immediate: !0
	} },
	async created() {
		if (this.activityRecordsGetter) try {
			this.isLoading = !0, console.log("Fetching activity records using getter...");
			let e = await this.activityRecordsGetter();
			Array.isArray(e) ? (this.localActivityRecords = e.filter((e) => {
				if (!e || !e.timeStamp) return !1;
				try {
					let t = q(e.timeStamp);
					return t.isValid() && t.year() > 2e3 && t.year() < 2100;
				} catch {
					return !1;
				}
			}), console.log(`Received ${e.length} records, ${this.localActivityRecords.length} valid after filtering`), this.processRecords(), this.createWeeksData()) : (console.error("Activity records getter did not return an array:", e), this.localActivityRecords = []);
		} catch (e) {
			console.error("Error fetching activity records:", e), this.localActivityRecords = [];
		} finally {
			this.isLoading = !1;
		}
		else console.log("No activityRecordsGetter provided, using direct activityRecords prop");
	},
	methods: {
		toDateString(e) {
			let t = q(e);
			return q.months()[t.month()] + " " + t.date();
		},
		processRecords() {
			let e = this.effectiveActivityRecords || [];
			console.log(`Processing ${e.length} records`);
			let t = {};
			if (e.length === 0) {
				console.log("No records to process"), this.heatmapData = t;
				return;
			}
			let n = /* @__PURE__ */ new Set(), r = {}, i = 0, a = 0;
			for (let o = 0; o < e.length; o++) {
				let s = e[o];
				if (!s || typeof s != "object" || !s.timeStamp) {
					a++;
					continue;
				}
				try {
					let e;
					if (typeof s.timeStamp == "string") e = q(s.timeStamp).format("YYYY-MM-DD");
					else if (typeof s.timeStamp == "number") e = q(new Date(s.timeStamp)).format("YYYY-MM-DD");
					else if (typeof s.timeStamp == "object") e = typeof s.timeStamp.format == "function" ? s.timeStamp.format("YYYY-MM-DD") : s.timeStamp instanceof Date ? q(s.timeStamp).format("YYYY-MM-DD") : q(String(s.timeStamp)).format("YYYY-MM-DD");
					else {
						a++;
						continue;
					}
					if (q(e, "YYYY-MM-DD", !0).isValid()) {
						t[e] = (t[e] || 0) + 1, n.add(e);
						let a = e.substring(0, 7);
						r[a] = (r[a] || 0) + 1, i++;
					} else a++;
				} catch {
					a++;
				}
			}
			console.log(`Processed ${i} valid dates, ${a} invalid dates`), console.log(`Found ${n.size} unique dates`), console.log("Date distribution by month:", r), this.heatmapData = t;
		},
		createWeeksData() {
			this.weeks = [], this.maxInRange = 0;
			let e = q(), t = e.clone().subtract(52, "weeks"), n = t.clone().startOf("week");
			console.log("Creating weeks data from", t.format("YYYY-MM-DD"), "to", e.format("YYYY-MM-DD")), Object.keys(this.heatmapData).length === 0 && console.log("No heatmap data available to display");
			let r = Object.keys(this.heatmapData).slice(0, 5);
			for (console.log("Sample dates in heatmap data:", r); n.isSameOrBefore(e);) {
				let e = [];
				for (let t = 0; t < 7; t++) {
					let t = n.format("YYYY-MM-DD"), r = {
						date: t,
						count: this.heatmapData[t] || 0
					};
					e.push(r), r.count > this.maxInRange && (this.maxInRange = r.count), n.add(1, "day");
				}
				this.weeks.push(e);
			}
			console.log("Weeks data created, maxInRange:", this.maxInRange);
			let i = 0, a = 0;
			Object.values(this.heatmapData).forEach((e) => {
				i++, a += e;
			}), console.log(`Activity summary: ${a} activities across ${i} days`);
		},
		getColor(e) {
			if (this.maxInRange === 0) return this.hslToString(this.inactiveColor);
			let t = e === 0 ? 0 : Math.min(2 * e / this.maxInRange, 1), n = this.activeColor;
			if (this.enableSeasonalColors) {
				let e = q();
				e.month() === 11 && e.date() >= 5 ? n = Math.random() > .5 ? {
					h: 350,
					s: .8,
					l: .5
				} : {
					h: 135,
					s: .8,
					l: .4
				} : e.month() === 9 && e.date() >= 25 && (n = Math.random() > .5 ? {
					h: 0,
					s: 0,
					l: 0
				} : Math.random() > .5 ? {
					h: 30,
					s: 1,
					l: .5
				} : {
					h: 270,
					s: 1,
					l: .5
				});
			}
			let r = n.h, i = this.interpolate(this.inactiveColor.s, n.s, t), a = this.interpolate(this.inactiveColor.l, n.l, t);
			return this.hslToString({
				h: r,
				s: i,
				l: a
			});
		},
		interpolate(e, t, n) {
			return e + (t - e) * n;
		},
		hslToString(e) {
			return `hsl(${e.h}, ${e.s * 100}%, ${e.l * 100}%)`;
		},
		showTooltip(e, t) {
			this.tooltipData = e, this.tooltipStyle = {
				position: "absolute",
				left: `${t.pageX + 10}px`,
				top: `${t.pageY + 10}px`
			};
		},
		hideTooltip() {
			this.tooltipData = null;
		}
	}
}), De = ["width", "height"], Oe = ["transform"], ke = [
	"y",
	"width",
	"height",
	"fill",
	"onMouseover"
];
function _sfc_render$26(e, t, n, r, i, a) {
	return L(), O("div", null, [(L(), O("svg", {
		width: e.width,
		height: e.height
	}, [(L(!0), O(C, null, z(e.weeks, (n, r) => (L(), O("g", {
		key: r,
		transform: `translate(${r * (e.cellSize + e.cellMargin)}, 0)`
	}, [(L(!0), O(C, null, z(n, (n, r) => (L(), O("rect", {
		key: n.date,
		x: 0,
		y: r * (e.cellSize + e.cellMargin),
		width: e.cellSize,
		height: e.cellSize,
		fill: e.getColor(n.count),
		onMouseover: (t) => e.showTooltip(n, t),
		onMouseout: t[0] || (t[0] = (...t) => e.hideTooltip && e.hideTooltip(...t))
	}, null, 40, ke))), 128))], 8, Oe))), 128))], 8, De)), e.tooltipData ? (L(), O("div", {
		key: 0,
		class: "tooltip",
		style: oe(e.tooltipStyle)
	}, H(e.tooltipData.count) + " review" + H(e.tooltipData.count === 1 ? "" : "s") + " on " + H(e.toDateString(e.tooltipData.date)), 5)) : D("", !0)]);
}
t(_sfc_render$26, "_sfc_render");
var Ae = /* @__PURE__ */ r(Ee, [["render", _sfc_render$26], ["__scopeId", "data-v-ca46239a"]]), je = M({
	name: "SkMouseTrap",
	props: { refreshInterval: {
		type: Number,
		default: 500
	} },
	data() {
		return {
			commands: [],
			display: !1,
			intervalId: null
		};
	},
	created() {
		this.intervalId = window.setInterval(this.refreshState, this.refreshInterval);
	},
	beforeUnmount() {
		this.intervalId !== null && clearInterval(this.intervalId);
	},
	methods: { refreshState() {
		this.commands = e.commands, this.display = this.commands.length > 0;
	} }
}), Me = { class: "text-caption ml-2" };
function _sfc_render$25(e, t, n, r, i, a) {
	let o = V("v-icon"), s = V("v-btn"), c = V("v-toolbar-title"), l = V("v-toolbar"), u = V("v-spacer"), d = V("v-list-item"), f = V("v-list"), p = V("v-card"), m = V("v-dialog");
	return e.display ? (L(), E(m, {
		key: 0,
		"max-width": "500px",
		transition: "dialog-transition"
	}, {
		activator: W(({ props: e }) => [j(s, P({
			icon: "",
			color: "primary"
		}, e), {
			default: W(() => [j(o, null, {
				default: W(() => t[0] || (t[0] = [A("mdi-keyboard")])),
				_: 1
			})]),
			_: 2
		}, 1040)]),
		default: W(() => [j(p, null, {
			default: W(() => [j(l, {
				color: "secondary",
				dark: "",
				dense: ""
			}, {
				default: W(() => [j(c, { class: "text-subtitle-1" }, {
					default: W(() => t[1] || (t[1] = [A("Shortcut keys:")])),
					_: 1
				})]),
				_: 1
			}), j(f, { dense: "" }, {
				default: W(() => [(L(!0), O(C, null, z(e.commands, (e) => (L(), E(d, {
					key: Array.isArray(e.hotkey) ? e.hotkey.join(",") : e.hotkey,
					class: "py-1"
				}, {
					default: W(() => [
						j(s, {
							variant: "outlined",
							color: "primary",
							class: "text-white",
							size: "small"
						}, {
							default: W(() => [A(H(Array.isArray(e.hotkey) ? e.hotkey[0] : e.hotkey), 1)]),
							_: 2
						}, 1024),
						j(u),
						k("span", Me, H(e.command), 1)
					]),
					_: 2
				}, 1024))), 128))]),
				_: 1
			})]),
			_: 1
		})]),
		_: 1
	})) : D("", !0);
}
t(_sfc_render$25, "_sfc_render");
var Ne = /* @__PURE__ */ r(je, [["render", _sfc_render$25]]), Pe = M({
	name: "SkMouseTrapToolTip",
	props: {
		hotkey: {
			type: [String, Array],
			required: !0
		},
		command: {
			type: String,
			required: !0
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		position: {
			type: String,
			default: "top"
		},
		showTooltip: {
			type: Boolean,
			default: !0
		},
		highlightEffect: {
			type: String,
			default: "glow"
		}
	},
	emits: ["hotkey-triggered"],
	setup(t, { emit: n }) {
		let r = R(null), i = R(!1);
		R(`hotkey-${Math.random().toString(36).substring(2, 15)}`);
		let a = T(() => {
			let e = Array.isArray(t.hotkey) ? t.hotkey[0] : t.hotkey;
			return e.includes(" ") ? e.toLowerCase().split(" ").map((e) => e.charAt(0) + e.slice(1)).join(", ") : e.toLowerCase().split("+").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" + ");
		});
		U(() => i.value, (e) => {
			if (!r.value || t.disabled) return;
			let n = r.value.querySelector("button, a, input[type=\"button\"], [role=\"button\"]");
			n && (n.style.transition = "all 250ms ease", e && t.highlightEffect !== "none" ? n.style.filter = "brightness(1.1)" : n.style.filter = "");
		});
		let handleKeyDown = (e) => {
			e.key === "Control" && (i.value = !0);
		}, handleKeyUp = (e) => {
			e.key === "Control" && (i.value = !1);
		}, handleHotkeyPress = () => {
			if (t.disabled || !r.value) return;
			let e = r.value.querySelector("button, a, input[type=\"button\"], [role=\"button\"]");
			if (e || (e = r.value.querySelector("v-list-item, .v-list-item, router-link, .router-link, a, [to]")), !e && (r.value.hasAttribute("to") || r.value.tagName === "A" || r.value.classList.contains("v-list-item")) && (e = r.value), !e) {
				let t = r.value.closest("v-list-item, .v-list-item, a, [to]");
				t && (e = t);
			}
			if (e) if (e.hasAttribute("to")) {
				let r = e.getAttribute("to");
				if (r && window.location.pathname !== r) {
					let e = window.$nuxt?.$router || window.$router;
					e && typeof e.push == "function" ? e.push(r) : window.location.pathname = r;
				}
				n("hotkey-triggered", t.hotkey);
			} else e.click(), n("hotkey-triggered", t.hotkey);
			else console.log("No clickable element found for hotkey", t.hotkey), n("hotkey-triggered", t.hotkey);
		}, registerHotkey = () => {
			t.disabled || e.addBinding({
				hotkey: t.hotkey,
				command: t.command,
				callback: handleHotkeyPress
			});
		}, unregisterHotkey = () => {
			t.disabled || e.removeBinding(t.hotkey);
		};
		return U(() => t.disabled, (e) => {
			e ? unregisterHotkey() : registerHotkey();
		}), I(() => {
			document.addEventListener("keydown", handleKeyDown), document.addEventListener("keyup", handleKeyUp), registerHotkey();
		}), se(() => {
			document.removeEventListener("keydown", handleKeyDown), document.removeEventListener("keyup", handleKeyUp), unregisterHotkey();
		}), {
			wrapperElement: r,
			isControlKeyPressed: i,
			formattedHotkey: a
		};
	}
});
//#endregion
//#region src/components/SkMouseTrapToolTip.vue
function _sfc_render$24(e, t, n, r, i, a) {
	return L(), O("div", {
		class: F(["sk-mousetrap-tooltip-wrapper", [e.isControlKeyPressed && !e.disabled && e.highlightEffect !== "none" ? `sk-mousetrap-highlight-${e.highlightEffect}` : ""]]),
		ref: "wrapperElement"
	}, [B(e.$slots, "default", {}, void 0, !0), j(w, { name: "fade" }, {
		default: W(() => [e.showTooltip && e.isControlKeyPressed && !e.disabled ? (L(), O("div", {
			key: 0,
			class: F(["sk-mousetrap-tooltip", {
				"sk-mt-tooltip-top": e.position === "top",
				"sk-mt-tooltip-bottom": e.position === "bottom",
				"sk-mt-tooltip-left": e.position === "left",
				"sk-mt-tooltip-right": e.position === "right"
			}])
		}, H(e.formattedHotkey), 3)) : D("", !0)]),
		_: 1
	})], 2);
}
t(_sfc_render$24, "_sfc_render");
var Fe = /* @__PURE__ */ r(Pe, [["render", _sfc_render$24], ["__scopeId", "data-v-5d6fb09c"]]), { setInstance: Ie, getInstance: Le, alertUser: Z } = (() => {
	let e = null;
	return {
		setInstance(t) {
			e = t;
		},
		getInstance() {
			return e;
		},
		alertUser(t) {
			let n = e;
			if (n) {
				n.addSnack(t);
				return;
			}
			console.error("SnackbarService not found");
		}
	};
})(), Re = M({
	name: "SnackbarService",
	data() {
		return {
			snacks: [],
			show: []
		};
	},
	mounted() {
		Ie(this);
	},
	methods: {
		addSnack(e) {
			this.snacks.push(e), this.show.push(!0);
		},
		close() {
			this.show.pop(), this.show.push(!1);
		},
		getColor(e) {
			if (e.status === J.ok) return "success";
			if (e.status === J.error) return "error";
			if (e.status === J.warning) return "yellow";
		}
	}
}), ze = { class: "d-flex align-center justify-space-between w-100" };
function _sfc_render$23(e, t, n, r, i, a) {
	let o = V("v-icon"), s = V("v-btn"), c = V("v-snackbar");
	return L(), O("div", null, [(L(!0), O(C, null, z(e.snacks, (n) => (L(), E(c, {
		key: e.snacks.indexOf(n),
		modelValue: e.show[e.snacks.indexOf(n)],
		"onUpdate:modelValue": (t) => e.show[e.snacks.indexOf(n)] = t,
		timeout: n.timeout,
		location: "bottom right",
		color: e.getColor(n)
	}, {
		default: W(() => [k("div", ze, [k("span", null, H(n.text), 1), j(s, {
			icon: "",
			variant: "text",
			onClick: t[0] || (t[0] = (t) => e.close())
		}, {
			default: W(() => [j(o, null, {
				default: W(() => t[1] || (t[1] = [A("mdi-close")])),
				_: 1
			})]),
			_: 1
		})])]),
		_: 2
	}, 1032, [
		"modelValue",
		"onUpdate:modelValue",
		"timeout",
		"color"
	]))), 128))]);
}
t(_sfc_render$23, "_sfc_render");
var Be = /* @__PURE__ */ r(Re, [["render", _sfc_render$23]]), Ve = M({
	name: "PaginatingToolbar",
	props: {
		pages: {
			type: Array,
			required: !0
		},
		page: {
			type: Number,
			required: !0
		},
		title: {
			type: String,
			required: !1,
			default: ""
		},
		subtitle: {
			type: String,
			required: !1,
			default: ""
		}
	},
	emits: [
		"first",
		"prev",
		"next",
		"last",
		"set-page"
	]
}), He = {
	key: 0,
	class: "ms-2 text-subtitle-2",
	"data-cy": "paginating-toolbar-subtitle"
};
function _sfc_render$22(e, t, n, r, i, a) {
	let o = V("v-toolbar-title"), s = V("v-spacer"), c = V("v-icon"), l = V("v-btn"), u = V("v-select"), d = V("v-toolbar");
	return L(), E(d, { density: "compact" }, {
		default: W(() => [
			j(o, null, {
				default: W(() => [k("span", null, H(e.title), 1), e.subtitle ? (L(), O("span", He, H(e.subtitle), 1)) : D("", !0)]),
				_: 1
			}),
			j(s),
			j(l, {
				variant: "text",
				icon: "",
				color: "secondary",
				disabled: e.page == 1,
				onClick: t[0] || (t[0] = (t) => e.$emit("first"))
			}, {
				default: W(() => [j(c, null, {
					default: W(() => t[5] || (t[5] = [A("mdi-page-first")])),
					_: 1
				})]),
				_: 1
			}, 8, ["disabled"]),
			j(l, {
				variant: "text",
				icon: "",
				color: "secondary",
				disabled: e.page == 1,
				onClick: t[1] || (t[1] = (t) => e.$emit("prev"))
			}, {
				default: W(() => [j(c, null, {
					default: W(() => t[6] || (t[6] = [A("mdi-chevron-left")])),
					_: 1
				})]),
				_: 1
			}, 8, ["disabled"]),
			j(u, {
				"model-value": e.page,
				items: e.pages,
				class: "pageSelect",
				density: "compact",
				"hide-details": "",
				"return-object": !1,
				variant: "outlined",
				"onUpdate:modelValue": t[2] || (t[2] = (t) => e.$emit("set-page", t))
			}, {
				selection: W(({ item: e }) => [A(H(e.value), 1)]),
				_: 1
			}, 8, ["model-value", "items"]),
			j(l, {
				variant: "text",
				icon: "",
				color: "secondary",
				disabled: e.page == e.pages.length,
				onClick: t[3] || (t[3] = (t) => e.$emit("next"))
			}, {
				default: W(() => [j(c, null, {
					default: W(() => t[7] || (t[7] = [A("mdi-chevron-right")])),
					_: 1
				})]),
				_: 1
			}, 8, ["disabled"]),
			j(l, {
				variant: "text",
				icon: "",
				color: "secondary",
				disabled: e.page == e.pages.length,
				onClick: t[4] || (t[4] = (t) => e.$emit("last"))
			}, {
				default: W(() => [j(c, null, {
					default: W(() => t[8] || (t[8] = [A("mdi-page-last")])),
					_: 1
				})]),
				_: 1
			}, 8, ["disabled"])
		]),
		_: 1
	});
}
t(_sfc_render$22, "_sfc_render");
var Ue = /* @__PURE__ */ r(Ve, [["render", _sfc_render$22], ["__scopeId", "data-v-a75fea7e"]]), We = M({
	name: "CardSearch",
	emits: { search: (e) => typeof e == "string" },
	data() {
		return { query: "" };
	},
	methods: { search() {
		this.$emit("search", this.query);
	} }
}), Ge = { class: "card-search" };
function _sfc_render$21(e, t, n, r, i, a) {
	let o = V("v-text-field");
	return L(), O("div", Ge, [j(o, {
		modelValue: e.query,
		"onUpdate:modelValue": t[0] || (t[0] = (t) => e.query = t),
		label: "Search for cards...",
		"append-icon": "mdi-magnify",
		"onClick:append": e.search,
		onKeydown: G(e.search, ["enter"])
	}, null, 8, [
		"modelValue",
		"onClick:append",
		"onKeydown"
	])]);
}
t(_sfc_render$21, "_sfc_render");
var Ke = /* @__PURE__ */ r(We, [["render", _sfc_render$21]]), qe = M({
	name: "CardSearchResults",
	emits: { "card-selected": (e) => typeof e.cardId == "string" && typeof e.courseId == "string" },
	props: {
		query: {
			type: String,
			required: !0
		},
		dataLayer: {
			type: Object,
			required: !0
		},
		courseFilter: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			cards: [],
			loading: !1,
			error: null,
			selectedCardId: null
		};
	},
	watch: { query: {
		immediate: !0,
		handler(e) {
			e && this.fetchResults(e);
		}
	} },
	methods: {
		async fetchResults(e) {
			this.loading = !0, this.error = null;
			try {
				let t = [];
				if (this.courseFilter) t = [this.courseFilter], console.log(`Filtering search to course: ${this.courseFilter}`);
				else {
					let { CourseLookup: e } = await import("@vue-skuilder/db");
					t = (await e.allCourseWare()).map((e) => e._id).filter(Boolean), console.log(`Searching across all ${t.length} courses`);
				}
				let n = [];
				for (let r of t) {
					let t = await this.dataLayer.getCourseDB(r).searchCards(e);
					for (let e of t) n.push({
						...e,
						courseId: r
					});
				}
				this.cards = n, console.log(`Search completed: found ${n.length} cards across ${t.length} courses`);
			} catch (e) {
				this.error = "Error fetching search results.", console.error("Search error:", e);
			} finally {
				this.loading = !1;
			}
		},
		selectCard(e) {
			this.selectedCardId = e._id, this.$emit("card-selected", {
				cardId: e._id,
				courseId: e.courseId
			});
		}
	}
}), Je = { class: "card-search-results" }, Ye = { key: 0 }, Xe = { key: 1 }, Ze = { key: 2 };
function _sfc_render$20(e, t, n, r, i, a) {
	let o = V("v-list-item-title"), s = V("v-list-item-subtitle"), c = V("v-list-item"), l = V("v-list");
	return L(), O("div", Je, [e.loading ? (L(), O("div", Ye, "Loading...")) : e.error ? (L(), O("div", Xe, H(e.error), 1)) : (L(), O("div", Ze, [j(l, null, {
		default: W(() => [(L(!0), O(C, null, z(e.cards, (t) => (L(), E(c, {
			key: t._id,
			onClick: (n) => e.selectCard(t),
			class: F([{ "selected-card": t._id === e.selectedCardId }, "cursor-pointer"])
		}, {
			default: W(() => [j(o, null, {
				default: W(() => [A(H(t._id), 1)]),
				_: 2
			}, 1024), j(s, null, {
				default: W(() => [A("Course: " + H(t.courseId), 1)]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1032, ["onClick", "class"]))), 128))]),
		_: 1
	})]))]);
}
t(_sfc_render$20, "_sfc_render");
var Qe = /* @__PURE__ */ r(qe, [["render", _sfc_render$20], ["__scopeId", "data-v-285e13bd"]]), $e = M({
	name: "CardHistoryViewer",
	props: {
		cardId: {
			type: String,
			required: !0
		},
		courseId: {
			type: String,
			required: !0
		},
		userId: {
			type: String,
			required: !0
		},
		userDB: {
			type: Object,
			required: !0
		}
	},
	data() {
		return {
			history: [],
			cardHistory: null,
			bestIntervalHumanized: "",
			loading: !1,
			error: null,
			headers: [
				{
					title: "Timestamp",
					key: "formattedTimeStamp"
				},
				{
					title: "Interval",
					key: "userFriendlyInterval"
				},
				{
					title: "Time Spent (s)",
					key: "timeSpentSeconds"
				},
				{
					title: "Correct?",
					key: "isCorrect"
				},
				{
					title: "Performance",
					key: "performance"
				},
				{
					title: "Prior Attempts",
					key: "priorAttemps"
				},
				{
					title: "User Answer",
					key: "userAnswer"
				}
			]
		};
	},
	watch: {
		cardId: {
			immediate: !0,
			handler(e) {
				e && this.userDB && this.fetchHistory();
			}
		},
		userDB: { handler(e) {
			e && this.cardId && this.fetchHistory();
		} }
	},
	methods: { async fetchHistory() {
		this.loading = !0, this.error = null;
		try {
			let e = ye(this.courseId, this.cardId), t = await this.userDB.get(e);
			this.cardHistory = t, this.bestIntervalHumanized = q.duration(t.bestInterval, "seconds").humanize();
			let n = [...t.records].sort((e, t) => q(e.timeStamp).valueOf() - q(t.timeStamp).valueOf());
			this.history = n.map((e, t) => {
				let r = q(e.timeStamp), i = {
					...e,
					formattedTimeStamp: r.format("YYYY-MM-DD HH:mm:ss"),
					timeSpentSeconds: Math.round(e.timeSpent / 1e3),
					isCorrect: e.isCorrect,
					performance: e.performance,
					priorAttemps: e.priorAttemps,
					userAnswer: e.userAnswer
				};
				if (t > 0) {
					let e = q(n[t - 1].timeStamp), a = r.diff(e, "seconds", !0);
					i.intervalFromPrevious = Math.round(a * 100) / 100, i.userFriendlyInterval = `${i.intervalFromPrevious} sec (${q.duration(a, "seconds").humanize()})`;
				}
				return i;
			});
		} catch (e) {
			this.error = "Error fetching card history.", console.error(e);
		} finally {
			this.loading = !1;
		}
	} }
}), et = { class: "card-history-viewer" }, tt = { key: 0 }, nt = { key: 1 }, rt = {
	key: 2,
	class: "error-message"
}, it = { key: 3 };
function _sfc_render$19(e, t, n, r, i, a) {
	let o = V("v-card-title"), s = V("v-list-item-title"), c = V("v-list-item-subtitle"), l = V("v-list-item-content"), u = V("v-list-item"), d = V("v-card"), f = V("v-data-table");
	return L(), O("div", et, [e.userId ? (L(), O("h3", tt, "Card History for User: " + H(e.userId), 1)) : D("", !0), e.loading ? (L(), O("div", nt, "Loading...")) : e.error ? (L(), O("div", rt, H(e.error), 1)) : e.cardHistory ? (L(), O("div", it, [j(d, { class: "mb-4" }, {
		default: W(() => [
			j(o, null, {
				default: W(() => t[0] || (t[0] = [A("Summary")])),
				_: 1
			}),
			j(u, null, {
				default: W(() => [j(l, null, {
					default: W(() => [j(s, null, {
						default: W(() => [A("Best Interval: " + H(e.cardHistory.bestInterval) + " seconds (" + H(e.bestIntervalHumanized) + ")", 1)]),
						_: 1
					}), j(c, null, {
						default: W(() => t[1] || (t[1] = [A("The to-date largest interval between successful card reviews.")])),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			}),
			j(u, null, {
				default: W(() => [j(l, null, {
					default: W(() => [j(s, null, {
						default: W(() => [A("Lapses: " + H(e.cardHistory.lapses), 1)]),
						_: 1
					}), j(c, null, {
						default: W(() => t[2] || (t[2] = [A("The number of times that a card has been failed in review.")])),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			}),
			j(u, null, {
				default: W(() => [j(l, null, {
					default: W(() => [j(s, null, {
						default: W(() => [A("Streak: " + H(e.cardHistory.streak), 1)]),
						_: 1
					}), j(c, null, {
						default: W(() => t[3] || (t[3] = [A("The number of consecutive successful impressions on this card.")])),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			})
		]),
		_: 1
	}), j(f, {
		headers: e.headers,
		items: e.history,
		class: "elevation-1"
	}, null, 8, ["headers", "items"])])) : D("", !0)]);
}
t(_sfc_render$19, "_sfc_render");
var at = /* @__PURE__ */ r($e, [["render", _sfc_render$19], ["__scopeId", "data-v-a4bdfdfb"]]);
//#endregion
//#region src/composables/Displayable.ts
function isDefineComponent(e) {
	return e.__isFragment !== void 0;
}
var Displayable = class {
	constructor(e) {
		if (e.length === 0) throw Error("\nDisplayable Constructor was called with no view Data.\n            ");
		validateData(this.dataShapes(), e);
	}
};
S(Displayable, "dataShapes", void 0), S(Displayable, "views", void 0), S(Displayable, "seedData", void 0), S(Displayable, "acceptsUserData", !0);
function validateData(e, t) {
	for (let n = 0; n < e.length; n++) e[n].fields.forEach((e, r) => {
		console.log(`[Displayable] shape[${n}].field[${r}]:\n ${JSON.stringify(e)}`), t[n][e.name] === void 0 && e.type !== fe.MEDIA_UPLOADS && console.warn("[Displayable] missing data");
	});
}
var Question = class extends Displayable {
	displayedSkill(e, t) {
		console.warn("Question is running the reference implementation of displayedSkill.\n    Consider overriding!");
		let n = 5e3, r = Math.min(t, 10 * n), i = r / n, a = r > n ? .8 ** i : 1, o = this.isCorrect(e) ? 1 : 0;
		return o *= a, Math.min(o, 1);
	}
	evaluate(e, t) {
		return {
			isCorrect: this.isCorrect(e),
			performance: this.displayedSkill(e, t)
		};
	}
}, getApiBase = () => {
	let e = "fallback (empty string)", t = "";
	if (!t && typeof window < "u" && window.__SKUILDER_CONFIG__?.apiBase) {
		let n = window.__SKUILDER_CONFIG__.apiBase.replace(/\/$/, "");
		t = n.startsWith("/") ? n : `/${n}`, e = "window.__SKUILDER_CONFIG__.apiBase";
	}
	return console.log("[authAPI] getApiBase() called"), console.log("[authAPI]   source:", e), console.log("[authAPI]   result:", t), t;
};
async function sendVerificationEmail(e, t, n) {
	try {
		let r = {
			username: e,
			email: t
		};
		n && (r.origin = n);
		let i = await fetch(`${getApiBase()}/auth/send-verification`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			credentials: "include",
			body: JSON.stringify(r)
		});
		if (!i.ok) {
			let e = await i.text();
			return console.error("Send verification email error:", e), {
				ok: !1,
				error: `HTTP ${i.status}: ${i.statusText}`
			};
		}
		return await i.json();
	} catch (e) {
		return console.error("Send verification email fetch error:", e), {
			ok: !1,
			error: e instanceof Error ? e.message : "Network error"
		};
	}
}
async function verifyEmail(e) {
	try {
		let t = await fetch(`${getApiBase()}/auth/verify`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			credentials: "include",
			body: JSON.stringify({ token: e })
		});
		return t.ok ? await t.json() : {
			ok: !1,
			error: `HTTP ${t.status}: ${t.statusText}`
		};
	} catch (e) {
		return {
			ok: !1,
			error: e instanceof Error ? e.message : "Network error"
		};
	}
}
async function getUserStatus() {
	try {
		let e = await fetch(`${getApiBase()}/auth/status`, {
			method: "GET",
			headers: { "Content-Type": "application/json" },
			credentials: "include"
		});
		return e.ok ? await e.json() : {
			ok: !1,
			error: `HTTP ${e.status}: ${e.statusText}`
		};
	} catch (e) {
		return {
			ok: !1,
			error: e instanceof Error ? e.message : "Network error"
		};
	}
}
async function requestPasswordReset(e, t) {
	try {
		let n = { email: e };
		t && (n.origin = t);
		let r = await fetch(`${getApiBase()}/auth/request-reset`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			credentials: "include",
			body: JSON.stringify(n)
		});
		return r.ok ? await r.json() : {
			ok: !1,
			error: `HTTP ${r.status}: ${r.statusText}`
		};
	} catch (e) {
		return {
			ok: !1,
			error: e instanceof Error ? e.message : "Network error"
		};
	}
}
async function resetPassword(e, t) {
	try {
		let n = await fetch(`${getApiBase()}/auth/reset-password`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			credentials: "include",
			body: JSON.stringify({
				token: e,
				newPassword: t
			})
		});
		return n.ok ? await n.json() : {
			ok: !1,
			error: `HTTP ${n.status}: ${n.statusText}`
		};
	} catch (e) {
		return {
			ok: !1,
			error: e instanceof Error ? e.message : "Network error"
		};
	}
}
//#endregion
//#region src/composables/useEntitlements.ts
function useEntitlements(e) {
	let t = R({}), n = R(!1), r = R(null), i = T(() => {
		let n = t.value[e];
		if (!n) return {
			isActive: !1,
			isPaid: !1,
			daysRemaining: null,
			expiresDate: null
		};
		if (n.status === "paid") return {
			isActive: !0,
			isPaid: !0,
			daysRemaining: null,
			expiresDate: null
		};
		let r = n.expires;
		if (!r) return {
			isActive: !0,
			isPaid: !1,
			daysRemaining: null,
			expiresDate: null
		};
		let i = new Date(r), a = /* @__PURE__ */ new Date(), o = Math.ceil((i.getTime() - a.getTime()) / (1e3 * 60 * 60 * 24));
		return {
			isActive: o > 0,
			isPaid: !1,
			daysRemaining: Math.max(0, o),
			expiresDate: r
		};
	}), a = T(() => i.value.isPaid);
	async function fetchEntitlements() {
		n.value = !0, r.value = null;
		try {
			let e = await getUserStatus();
			e.ok ? t.value = e.entitlements || {} : (r.value = e.error || "Failed to fetch entitlements", console.error("[useEntitlements] Error:", r.value));
		} catch (e) {
			r.value = e instanceof Error ? e.message : "Unknown error", console.error("[useEntitlements] Exception:", e);
		} finally {
			n.value = !1;
		}
	}
	return {
		entitlements: t,
		trialStatus: i,
		hasPremiumAccess: a,
		loading: n,
		error: r,
		fetchEntitlements
	};
}
//#endregion
//#region src/components/StudySessionTimer.vue?vue&type=script&lang.ts
var ot = M({
	name: "StudySessionTimer",
	props: {
		timeRemaining: {
			type: Number,
			required: !0
		},
		sessionTimeLimit: {
			type: Number,
			required: !0,
			default: 5
		},
		allowAddTime: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["add-time"],
	setup(e, { emit: t }) {
		let n = R(!1), r = T(() => {
			let t = "", n = e.timeRemaining;
			n > 60 && (t = Math.floor(n / 60).toString() + ":");
			let r = n % 60;
			return t += r >= 10 ? r : "0" + r, n <= 60 && (t += " seconds"), t += " left!", t;
		}), i = T(() => e.timeRemaining > 60 ? 100 * (e.timeRemaining / (60 * e.sessionTimeLimit)) : 100 * (e.timeRemaining / 60)), a = T(() => e.timeRemaining > 60 ? "primary" : "orange darken-3"), addSessionTime = () => {
			t("add-time");
		};
		return {
			hovered: n,
			formattedTimeRemaining: r,
			percentageRemaining: i,
			timerColor: a,
			addSessionTime
		};
	}
});
//#endregion
//#region src/components/StudySessionTimer.vue
function _sfc_render$18(e, t, n, r, i, a) {
	let o = V("v-icon"), s = V("v-btn"), c = V("v-progress-circular"), l = V("v-tooltip");
	return L(), E(l, {
		location: "right",
		"open-delay": 0,
		"close-delay": 200,
		color: "secondary",
		class: "text-subtitle-1"
	}, {
		activator: W(({ props: n }) => [k("div", P({ class: "timer-container" }, n, {
			onMouseenter: t[0] || (t[0] = (t) => e.hovered = !0),
			onMouseleave: t[1] || (t[1] = (t) => e.hovered = !1)
		}), [j(c, {
			alt: "Time remaining in study session",
			size: "64",
			width: "8",
			rotate: "0",
			color: e.timerColor,
			"model-value": e.percentageRemaining
		}, {
			default: W(() => [e.allowAddTime && e.timeRemaining > 0 && e.hovered ? (L(), E(s, {
				key: 0,
				icon: "",
				color: "transparent",
				location: "bottom left",
				onClick: e.addSessionTime
			}, {
				default: W(() => [j(o, { size: "large" }, {
					default: W(() => t[2] || (t[2] = [A("mdi-plus")])),
					_: 1
				})]),
				_: 1
			}, 8, ["onClick"])) : D("", !0)]),
			_: 1
		}, 8, ["color", "model-value"])], 16)]),
		default: W(() => [A(" " + H(e.formattedTimeRemaining), 1)]),
		_: 1
	});
}
t(_sfc_render$18, "_sfc_render");
var st = /* @__PURE__ */ r(ot, [["render", _sfc_render$18], ["__scopeId", "data-v-5e104ccc"]]), ct = M({
	name: "CardViewer",
	ref: {},
	props: {
		sessionOrder: {
			type: Number,
			required: !1,
			default: 0
		},
		card_id: {
			type: String,
			required: !0,
			default: ""
		},
		course_id: {
			type: String,
			required: !0,
			default: ""
		},
		view: {
			type: [Function, Object],
			required: !0
		},
		data: {
			type: Array,
			required: !0
		},
		user_elo: {
			type: Object,
			default: () => ({
				global: {
					score: 1e3,
					count: 0
				},
				tags: {},
				misc: {}
			})
		},
		card_elo: {
			type: Number,
			default: 1e3
		},
		frameless: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"emitResponse",
		"requestReplan",
		"readyToAdvance"
	],
	methods: { processResponse(e) {
		console.log(`
        Card was displayed at ${e.timeStamp}
        User spent ${e.timeSpent} milliseconds with the card.
        `), this.$emit("emitResponse", e);
	} }
});
//#endregion
//#region src/components/cardRendering/CardViewer.vue
function _sfc_render$17(e, t, n, r, i, a) {
	let o = V("v-card");
	return e.frameless ? (L(), E(le(e.view), {
		ref: "activeView",
		key: e.course_id + "-" + e.card_id + "-" + e.sessionOrder,
		data: e.data,
		"modify-difficulty": e.user_elo.global.score - e.card_elo,
		class: "cardView",
		onEmitResponse: t[0] || (t[0] = (t) => e.processResponse(t)),
		onRequestReplan: t[1] || (t[1] = (t) => e.$emit("requestReplan", t)),
		onReadyToAdvance: t[2] || (t[2] = (t) => e.$emit("readyToAdvance"))
	}, null, 40, ["data", "modify-difficulty"])) : (L(), E(o, {
		key: 1,
		elevation: "12"
	}, {
		default: W(() => [(L(), E(le(e.view), {
			ref: "activeView",
			key: e.course_id + "-" + e.card_id + "-" + e.sessionOrder,
			data: e.data,
			"modify-difficulty": e.user_elo.global.score - e.card_elo,
			class: "cardView ma-2 pa-2",
			onEmitResponse: t[3] || (t[3] = (t) => e.processResponse(t)),
			onRequestReplan: t[4] || (t[4] = (t) => e.$emit("requestReplan", t)),
			onReadyToAdvance: t[5] || (t[5] = (t) => e.$emit("readyToAdvance"))
		}, null, 40, ["data", "modify-difficulty"]))]),
		_: 1
	}));
}
t(_sfc_render$17, "_sfc_render");
var Q = /* @__PURE__ */ r(ct, [["render", _sfc_render$17], ["__scopeId", "data-v-2d892b82"]]), lt = M({
	name: "SessionControllerDebug",
	props: { sessionController: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = R(0), n = null;
		I(() => {
			n = setInterval(() => {
				t.value++;
			}, 500);
		}), ce(() => {
			n && clearInterval(n);
		});
		let r = T(() => (t.value, e.sessionController ? e.sessionController.getDebugInfo() : {
			supplyQueue: {
				length: 0,
				dequeueCount: 0,
				items: []
			},
			failedQueue: {
				length: 0,
				dequeueCount: 0,
				items: []
			},
			hydratedCache: {
				count: 0,
				failedCacheSize: 0,
				items: []
			}
		})), fmtScore = (e) => e === void 0 ? "" : Number.isFinite(e) ? e.toFixed(2) : "REQ";
		return {
			debugInfo: r,
			fmtScore
		};
	}
}), ut = { class: "debug-section" }, dt = { class: "debug-header" }, ft = { class: "debug-stats" }, pt = { class: "text-caption" }, mt = { class: "text-caption ml-2" }, ht = {
	key: 0,
	class: "debug-items"
}, gt = { class: "text-caption" }, _t = { class: "text-caption text-grey ml-1" }, vt = {
	class: "text-caption ml-1",
	style: { color: "#90caf9" }
}, yt = {
	key: 0,
	class: "text-caption text-grey"
}, bt = {
	key: 1,
	class: "text-caption text-grey"
}, xt = { class: "debug-section" }, St = { class: "debug-header" }, Ct = { class: "debug-stats" }, wt = { class: "text-caption" }, Tt = { class: "text-caption ml-2" }, Et = {
	key: 0,
	class: "debug-items"
}, Dt = { class: "text-caption" }, Ot = { class: "text-caption text-grey ml-1" }, kt = {
	key: 0,
	class: "text-caption text-grey"
}, At = {
	key: 1,
	class: "text-caption text-grey"
}, jt = { class: "debug-section" }, Mt = { class: "debug-header" }, Nt = { class: "debug-stats" }, Pt = { class: "text-caption" }, Ft = { class: "text-caption ml-2" }, It = {
	key: 0,
	class: "debug-items"
}, Lt = { class: "text-caption" }, Rt = {
	key: 0,
	class: "text-caption text-grey"
}, zt = {
	key: 1,
	class: "text-caption text-grey"
};
function _sfc_render$16(e, t, n, r, i, a) {
	let o = V("v-spacer"), s = V("v-icon"), c = V("v-card-title"), l = V("v-col"), u = V("v-row"), d = V("v-divider"), f = V("v-card-text"), p = V("v-card");
	return e.sessionController ? (L(), E(p, {
		key: 0,
		class: "session-debug ma-2",
		elevation: "2"
	}, {
		default: W(() => [j(c, { class: "text-caption bg-grey-darken-3" }, {
			default: W(() => [
				t[1] || (t[1] = A(" Session Controller Debug ")),
				j(o),
				j(s, { size: "small" }, {
					default: W(() => t[0] || (t[0] = [A("mdi-bug")])),
					_: 1
				})
			]),
			_: 1
		}), j(f, { class: "pa-2" }, {
			default: W(() => [j(u, { dense: "" }, {
				default: W(() => [j(l, {
					cols: "12",
					md: "8"
				}, {
					default: W(() => [k("div", ut, [
						k("div", dt, [j(s, {
							size: "x-small",
							class: "mr-1"
						}, {
							default: W(() => t[2] || (t[2] = [A("mdi-sort")])),
							_: 1
						}), t[3] || (t[3] = k("strong", null, "Supply Queue", -1))]),
						k("div", ft, [k("span", pt, "Length: " + H(e.debugInfo.supplyQueue.length), 1), k("span", mt, "Dequeued: " + H(e.debugInfo.supplyQueue.dequeueCount), 1)]),
						e.debugInfo.supplyQueue.items.length > 0 ? (L(), O("div", ht, [(L(!0), O(C, null, z(e.debugInfo.supplyQueue.items.slice(0, 8), (t, n) => (L(), O("div", {
							key: n,
							class: "debug-item"
						}, [
							k("span", gt, H(n) + ": " + H(t.courseID) + "::" + H(t.cardID), 1),
							k("span", _t, "(" + H(t.status) + ")", 1),
							k("span", vt, H(e.fmtScore(t.score)), 1)
						]))), 128)), e.debugInfo.supplyQueue.items.length > 8 ? (L(), O("div", yt, " ... +" + H(e.debugInfo.supplyQueue.items.length - 8) + " more ", 1)) : D("", !0)])) : (L(), O("div", bt, " (empty) "))
					])]),
					_: 1
				}), j(l, {
					cols: "12",
					md: "4"
				}, {
					default: W(() => [k("div", xt, [
						k("div", St, [j(s, {
							size: "x-small",
							class: "mr-1"
						}, {
							default: W(() => t[4] || (t[4] = [A("mdi-alert-circle")])),
							_: 1
						}), t[5] || (t[5] = k("strong", null, "Failed Cards Queue", -1))]),
						k("div", Ct, [k("span", wt, "Length: " + H(e.debugInfo.failedQueue.length), 1), k("span", Tt, "Dequeued: " + H(e.debugInfo.failedQueue.dequeueCount), 1)]),
						e.debugInfo.failedQueue.items.length > 0 ? (L(), O("div", Et, [(L(!0), O(C, null, z(e.debugInfo.failedQueue.items.slice(0, 5), (e, t) => (L(), O("div", {
							key: t,
							class: "debug-item"
						}, [k("span", Dt, H(t) + ": " + H(e.courseID) + "::" + H(e.cardID), 1), k("span", Ot, "(" + H(e.status) + ")", 1)]))), 128)), e.debugInfo.failedQueue.items.length > 5 ? (L(), O("div", kt, " ... +" + H(e.debugInfo.failedQueue.items.length - 5) + " more ", 1)) : D("", !0)])) : (L(), O("div", At, " (empty) "))
					])]),
					_: 1
				})]),
				_: 1
			}), j(u, { dense: "" }, {
				default: W(() => [j(l, { cols: "12" }, {
					default: W(() => [j(d, { class: "my-2" }), k("div", jt, [
						k("div", Mt, [j(s, {
							size: "x-small",
							class: "mr-1"
						}, {
							default: W(() => t[6] || (t[6] = [A("mdi-database")])),
							_: 1
						}), t[7] || (t[7] = k("strong", null, "Hydrated Cards Cache", -1))]),
						k("div", Nt, [k("span", Pt, "Cached: " + H(e.debugInfo.hydratedCache.count), 1), k("span", Ft, "Failed Cache: " + H(e.debugInfo.hydratedCache.failedCacheSize), 1)]),
						e.debugInfo.hydratedCache.items.length > 0 ? (L(), O("div", It, [(L(!0), O(C, null, z(e.debugInfo.hydratedCache.items.slice(0, 8), (e, t) => (L(), O("div", {
							key: t,
							class: "debug-item d-inline-block mr-3"
						}, [k("span", Lt, H(e.courseID) + "::" + H(e.cardID), 1)]))), 128)), e.debugInfo.hydratedCache.items.length > 8 ? (L(), O("div", Rt, " ... +" + H(e.debugInfo.hydratedCache.items.length - 8) + " more ", 1)) : D("", !0)])) : (L(), O("div", zt, " (empty) "))
					])]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		})]),
		_: 1
	})) : D("", !0);
}
t(_sfc_render$16, "_sfc_render");
var Bt = /* @__PURE__ */ r(lt, [["render", _sfc_render$16], ["__scopeId", "data-v-641ac170"]]), Vt = {};
(function main(e, t, n, r) {
	var i = !!(e.Worker && e.Blob && e.Promise && e.OffscreenCanvas && e.OffscreenCanvasRenderingContext2D && e.HTMLCanvasElement && e.HTMLCanvasElement.prototype.transferControlToOffscreen && e.URL && e.URL.createObjectURL), a = typeof Path2D == "function" && typeof DOMMatrix == "function", o = (function() {
		if (!e.OffscreenCanvas) return !1;
		var t = new OffscreenCanvas(1, 1), n = t.getContext("2d");
		n.fillRect(0, 0, 1, 1);
		var r = t.transferToImageBitmap();
		try {
			n.createPattern(r, "no-repeat");
		} catch {
			return !1;
		}
		return !0;
	})();
	function noop() {}
	function promise(n) {
		var r = t.exports.Promise, i = r === void 0 ? e.Promise : r;
		return typeof i == "function" ? new i(n) : (n(noop, noop), null);
	}
	var s = (function(e, t) {
		return {
			transform: function(n) {
				if (e) return n;
				if (t.has(n)) return t.get(n);
				var r = new OffscreenCanvas(n.width, n.height);
				return r.getContext("2d").drawImage(n, 0, 0), t.set(n, r), r;
			},
			clear: function() {
				t.clear();
			}
		};
	})(o, /* @__PURE__ */ new Map()), c = function() {
		var e = 16, frame, cancel, t = {}, n = 0;
		return typeof requestAnimationFrame == "function" && typeof cancelAnimationFrame == "function" ? (frame = function(r) {
			var i = Math.random();
			return t[i] = requestAnimationFrame(function onFrame(a) {
				n === a || n + e - 1 < a ? (n = a, delete t[i], r()) : t[i] = requestAnimationFrame(onFrame);
			}), i;
		}, cancel = function(e) {
			t[e] && cancelAnimationFrame(t[e]);
		}) : (frame = function(t) {
			return setTimeout(t, e);
		}, cancel = function(e) {
			return clearTimeout(e);
		}), {
			frame,
			cancel
		};
	}(), l = (function() {
		var e, t, r = {};
		function decorate(e) {
			function execute(t, n) {
				e.postMessage({
					options: t || {},
					callback: n
				});
			}
			e.init = function initWorker(t) {
				var n = t.transferControlToOffscreen();
				e.postMessage({ canvas: n }, [n]);
			}, e.fire = function fireWorker(n, i, a) {
				if (t) return execute(n, null), t;
				var o = Math.random().toString(36).slice(2);
				return t = promise(function(i) {
					function workerDone(n) {
						n.data.callback === o && (delete r[o], e.removeEventListener("message", workerDone), t = null, s.clear(), a(), i());
					}
					e.addEventListener("message", workerDone), execute(n, o), r[o] = workerDone.bind(null, { data: { callback: o } });
				}), t;
			}, e.reset = function resetWorker() {
				for (var t in e.postMessage({ reset: !0 }), r) r[t](), delete r[t];
			};
		}
		return function() {
			if (e) return e;
			if (!n && i) {
				var t = [
					"var CONFETTI, SIZE = {}, module = {};",
					"(" + main.toString() + ")(this, module, true, SIZE);",
					"onmessage = function(msg) {",
					"  if (msg.data.options) {",
					"    CONFETTI(msg.data.options).then(function () {",
					"      if (msg.data.callback) {",
					"        postMessage({ callback: msg.data.callback });",
					"      }",
					"    });",
					"  } else if (msg.data.reset) {",
					"    CONFETTI && CONFETTI.reset();",
					"  } else if (msg.data.resize) {",
					"    SIZE.width = msg.data.resize.width;",
					"    SIZE.height = msg.data.resize.height;",
					"  } else if (msg.data.canvas) {",
					"    SIZE.width = msg.data.canvas.width;",
					"    SIZE.height = msg.data.canvas.height;",
					"    CONFETTI = module.exports.create(msg.data.canvas);",
					"  }",
					"}"
				].join("\n");
				try {
					e = new Worker(URL.createObjectURL(new Blob([t])));
				} catch (e) {
					return typeof console.warn == "function" && console.warn("🎊 Could not load worker", e), null;
				}
				decorate(e);
			}
			return e;
		};
	})(), u = {
		particleCount: 50,
		angle: 90,
		spread: 45,
		startVelocity: 45,
		decay: .9,
		gravity: 1,
		drift: 0,
		ticks: 200,
		x: .5,
		y: .5,
		shapes: ["square", "circle"],
		zIndex: 100,
		colors: [
			"#26ccff",
			"#a25afd",
			"#ff5e7e",
			"#88ff5a",
			"#fcff42",
			"#ffa62d",
			"#ff36ff"
		],
		disableForReducedMotion: !1,
		scalar: 1
	};
	function convert(e, t) {
		return t ? t(e) : e;
	}
	function isOk(e) {
		return e != null;
	}
	function prop(e, t, n) {
		return convert(e && isOk(e[t]) ? e[t] : u[t], n);
	}
	function onlyPositiveInt(e) {
		return e < 0 ? 0 : Math.floor(e);
	}
	function randomInt(e, t) {
		return Math.floor(Math.random() * (t - e)) + e;
	}
	function toDecimal(e) {
		return parseInt(e, 16);
	}
	function colorsToRgb(e) {
		return e.map(hexToRgb);
	}
	function hexToRgb(e) {
		var t = String(e).replace(/[^0-9a-f]/gi, "");
		return t.length < 6 && (t = t[0] + t[0] + t[1] + t[1] + t[2] + t[2]), {
			r: toDecimal(t.substring(0, 2)),
			g: toDecimal(t.substring(2, 4)),
			b: toDecimal(t.substring(4, 6))
		};
	}
	function getOrigin(e) {
		var t = prop(e, "origin", Object);
		return t.x = prop(t, "x", Number), t.y = prop(t, "y", Number), t;
	}
	function setCanvasWindowSize(e) {
		e.width = document.documentElement.clientWidth, e.height = document.documentElement.clientHeight;
	}
	function setCanvasRectSize(e) {
		var t = e.getBoundingClientRect();
		e.width = t.width, e.height = t.height;
	}
	function getCanvas(e) {
		var t = document.createElement("canvas");
		return t.style.position = "fixed", t.style.top = "0px", t.style.left = "0px", t.style.pointerEvents = "none", t.style.zIndex = e, t;
	}
	function ellipse(e, t, n, r, i, a, o, s, c) {
		e.save(), e.translate(t, n), e.rotate(a), e.scale(r, i), e.arc(0, 0, 1, o, s, c), e.restore();
	}
	function randomPhysics(e) {
		var t = e.angle * (Math.PI / 180), n = e.spread * (Math.PI / 180);
		return {
			x: e.x,
			y: e.y,
			wobble: Math.random() * 10,
			wobbleSpeed: Math.min(.11, Math.random() * .1 + .05),
			velocity: e.startVelocity * .5 + Math.random() * e.startVelocity,
			angle2D: -t + (.5 * n - Math.random() * n),
			tiltAngle: (Math.random() * .5 + .25) * Math.PI,
			color: e.color,
			shape: e.shape,
			tick: 0,
			totalTicks: e.ticks,
			decay: e.decay,
			drift: e.drift,
			random: Math.random() + 2,
			tiltSin: 0,
			tiltCos: 0,
			wobbleX: 0,
			wobbleY: 0,
			gravity: e.gravity * 3,
			ovalScalar: .6,
			scalar: e.scalar,
			flat: e.flat
		};
	}
	function updateFetti(e, t) {
		t.x += Math.cos(t.angle2D) * t.velocity + t.drift, t.y += Math.sin(t.angle2D) * t.velocity + t.gravity, t.velocity *= t.decay, t.flat ? (t.wobble = 0, t.wobbleX = t.x + 10 * t.scalar, t.wobbleY = t.y + 10 * t.scalar, t.tiltSin = 0, t.tiltCos = 0, t.random = 1) : (t.wobble += t.wobbleSpeed, t.wobbleX = t.x + 10 * t.scalar * Math.cos(t.wobble), t.wobbleY = t.y + 10 * t.scalar * Math.sin(t.wobble), t.tiltAngle += .1, t.tiltSin = Math.sin(t.tiltAngle), t.tiltCos = Math.cos(t.tiltAngle), t.random = Math.random() + 2);
		var n = t.tick++ / t.totalTicks, r = t.x + t.random * t.tiltCos, i = t.y + t.random * t.tiltSin, o = t.wobbleX + t.random * t.tiltCos, c = t.wobbleY + t.random * t.tiltSin;
		if (e.fillStyle = "rgba(" + t.color.r + ", " + t.color.g + ", " + t.color.b + ", " + (1 - n) + ")", e.beginPath(), a && t.shape.type === "path" && typeof t.shape.path == "string" && Array.isArray(t.shape.matrix)) e.fill(transformPath2D(t.shape.path, t.shape.matrix, t.x, t.y, Math.abs(o - r) * .1, Math.abs(c - i) * .1, Math.PI / 10 * t.wobble));
		else if (t.shape.type === "bitmap") {
			var l = Math.PI / 10 * t.wobble, u = Math.abs(o - r) * .1, d = Math.abs(c - i) * .1, f = t.shape.bitmap.width * t.scalar, p = t.shape.bitmap.height * t.scalar, m = new DOMMatrix([
				Math.cos(l) * u,
				Math.sin(l) * u,
				-Math.sin(l) * d,
				Math.cos(l) * d,
				t.x,
				t.y
			]);
			m.multiplySelf(new DOMMatrix(t.shape.matrix));
			var h = e.createPattern(s.transform(t.shape.bitmap), "no-repeat");
			h.setTransform(m), e.globalAlpha = 1 - n, e.fillStyle = h, e.fillRect(t.x - f / 2, t.y - p / 2, f, p), e.globalAlpha = 1;
		} else if (t.shape === "circle") e.ellipse ? e.ellipse(t.x, t.y, Math.abs(o - r) * t.ovalScalar, Math.abs(c - i) * t.ovalScalar, Math.PI / 10 * t.wobble, 0, 2 * Math.PI) : ellipse(e, t.x, t.y, Math.abs(o - r) * t.ovalScalar, Math.abs(c - i) * t.ovalScalar, Math.PI / 10 * t.wobble, 0, 2 * Math.PI);
		else if (t.shape === "star") for (var g = Math.PI / 2 * 3, _ = 4 * t.scalar, v = 8 * t.scalar, y = t.x, b = t.y, x = 5, S = Math.PI / x; x--;) y = t.x + Math.cos(g) * v, b = t.y + Math.sin(g) * v, e.lineTo(y, b), g += S, y = t.x + Math.cos(g) * _, b = t.y + Math.sin(g) * _, e.lineTo(y, b), g += S;
		else e.moveTo(Math.floor(t.x), Math.floor(t.y)), e.lineTo(Math.floor(t.wobbleX), Math.floor(i)), e.lineTo(Math.floor(o), Math.floor(c)), e.lineTo(Math.floor(r), Math.floor(t.wobbleY));
		return e.closePath(), e.fill(), t.tick < t.totalTicks;
	}
	function animate(e, t, i, a, o) {
		var l = t.slice(), u = e.getContext("2d"), d, f, p = promise(function(t) {
			function onDone() {
				d = f = null, u.clearRect(0, 0, a.width, a.height), s.clear(), o(), t();
			}
			function update() {
				n && !(a.width === r.width && a.height === r.height) && (a.width = e.width = r.width, a.height = e.height = r.height), !a.width && !a.height && (i(e), a.width = e.width, a.height = e.height), u.clearRect(0, 0, a.width, a.height), l = l.filter(function(e) {
					return updateFetti(u, e);
				}), l.length ? d = c.frame(update) : onDone();
			}
			d = c.frame(update), f = onDone;
		});
		return {
			addFettis: function(e) {
				return l = l.concat(e), p;
			},
			canvas: e,
			promise: p,
			reset: function() {
				d && c.cancel(d), f && f();
			}
		};
	}
	function confettiCannon(t, n) {
		var r = !t, a = !!prop(n || {}, "resize"), o = !1, s = prop(n, "disableForReducedMotion", Boolean), c = i && prop(n || {}, "useWorker") ? l() : null, u = r ? setCanvasWindowSize : setCanvasRectSize, d = t && c ? !!t.__confetti_initialized : !1, f = typeof matchMedia == "function" && matchMedia("(prefers-reduced-motion)").matches, p;
		function fireLocal(e, n, r) {
			for (var i = prop(e, "particleCount", onlyPositiveInt), a = prop(e, "angle", Number), o = prop(e, "spread", Number), s = prop(e, "startVelocity", Number), c = prop(e, "decay", Number), l = prop(e, "gravity", Number), d = prop(e, "drift", Number), f = prop(e, "colors", colorsToRgb), m = prop(e, "ticks", Number), h = prop(e, "shapes"), g = prop(e, "scalar"), _ = !!prop(e, "flat"), v = getOrigin(e), y = i, b = [], x = t.width * v.x, S = t.height * v.y; y--;) b.push(randomPhysics({
				x,
				y: S,
				angle: a,
				spread: o,
				startVelocity: s,
				color: f[y % f.length],
				shape: h[randomInt(0, h.length)],
				ticks: m,
				decay: c,
				gravity: l,
				drift: d,
				scalar: g,
				flat: _
			}));
			return p ? p.addFettis(b) : (p = animate(t, b, u, n, r), p.promise);
		}
		function fire(n) {
			var i = s || prop(n, "disableForReducedMotion", Boolean), l = prop(n, "zIndex", Number);
			if (i && f) return promise(function(e) {
				e();
			});
			r && p ? t = p.canvas : r && !t && (t = getCanvas(l), document.body.appendChild(t)), a && !d && u(t);
			var m = {
				width: t.width,
				height: t.height
			};
			c && !d && c.init(t), d = !0, c && (t.__confetti_initialized = !0);
			function onResize() {
				if (c) {
					var e = { getBoundingClientRect: function() {
						if (!r) return t.getBoundingClientRect();
					} };
					u(e), c.postMessage({ resize: {
						width: e.width,
						height: e.height
					} });
					return;
				}
				m.width = m.height = null;
			}
			function done() {
				p = null, a && (o = !1, e.removeEventListener("resize", onResize)), r && t && (document.body.contains(t) && document.body.removeChild(t), t = null, d = !1);
			}
			return a && !o && (o = !0, e.addEventListener("resize", onResize, !1)), c ? c.fire(n, m, done) : fireLocal(n, m, done);
		}
		return fire.reset = function() {
			c && c.reset(), p && p.reset();
		}, fire;
	}
	var d;
	function getDefaultFire() {
		return d || (d = confettiCannon(null, {
			useWorker: !0,
			resize: !0
		})), d;
	}
	function transformPath2D(e, t, n, r, i, a, o) {
		var s = new Path2D(e), c = new Path2D();
		c.addPath(s, new DOMMatrix(t));
		var l = new Path2D();
		return l.addPath(c, new DOMMatrix([
			Math.cos(o) * i,
			Math.sin(o) * i,
			-Math.sin(o) * a,
			Math.cos(o) * a,
			n,
			r
		])), l;
	}
	function shapeFromPath(e) {
		if (!a) throw Error("path confetti are not supported in this browser");
		var t, n;
		typeof e == "string" ? t = e : (t = e.path, n = e.matrix);
		var r = new Path2D(t), i = document.createElement("canvas").getContext("2d");
		if (!n) {
			for (var o = 1e3, s = o, c = o, l = 0, u = 0, d, f, p = 0; p < o; p += 2) for (var m = 0; m < o; m += 2) i.isPointInPath(r, p, m, "nonzero") && (s = Math.min(s, p), c = Math.min(c, m), l = Math.max(l, p), u = Math.max(u, m));
			d = l - s, f = u - c;
			var h = 10, g = Math.min(h / d, h / f);
			n = [
				g,
				0,
				0,
				g,
				-Math.round(d / 2 + s) * g,
				-Math.round(f / 2 + c) * g
			];
		}
		return {
			type: "path",
			path: t,
			matrix: n
		};
	}
	function shapeFromText(e) {
		var t, n = 1, r = "#000000", i = "\"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\", \"EmojiOne Color\", \"Android Emoji\", \"Twemoji Mozilla\", \"system emoji\", sans-serif";
		typeof e == "string" ? t = e : (t = e.text, n = "scalar" in e ? e.scalar : n, i = "fontFamily" in e ? e.fontFamily : i, r = "color" in e ? e.color : r);
		var a = 10 * n, o = "" + a + "px " + i, s = new OffscreenCanvas(a, a), c = s.getContext("2d");
		c.font = o;
		var l = c.measureText(t), u = Math.ceil(l.actualBoundingBoxRight + l.actualBoundingBoxLeft), d = Math.ceil(l.actualBoundingBoxAscent + l.actualBoundingBoxDescent), f = 2, p = l.actualBoundingBoxLeft + f, m = l.actualBoundingBoxAscent + f;
		u += f + f, d += f + f, s = new OffscreenCanvas(u, d), c = s.getContext("2d"), c.font = o, c.fillStyle = r, c.fillText(t, p, m);
		var h = 1 / n;
		return {
			type: "bitmap",
			bitmap: s.transferToImageBitmap(),
			matrix: [
				h,
				0,
				0,
				h,
				-u * h / 2,
				-d * h / 2
			]
		};
	}
	t.exports = function() {
		return getDefaultFire().apply(this, arguments);
	}, t.exports.reset = function() {
		getDefaultFire().reset();
	}, t.exports.create = confettiCannon, t.exports.shapeFromPath = shapeFromPath, t.exports.shapeFromText = shapeFromText;
})((function() {
	return typeof window < "u" ? window : typeof self < "u" ? self : this || {};
})(), Vt, !1);
var Ht = Vt.exports;
Vt.exports.create;
//#endregion
//#region src/components/StudySession.vue?vue&type=script&lang.ts
var Ut = M({
	name: "StudySession",
	ref: {},
	components: {
		CardViewer: Q,
		StudySessionTimer: st,
		SkMouseTrap: Ne,
		HeatMap: Ae,
		SessionControllerDebug: Bt
	},
	props: {
		sessionTimeLimit: {
			type: Number,
			required: !0
		},
		contentSources: {
			type: Array,
			required: !0
		},
		user: {
			type: Object,
			required: !0
		},
		dataLayer: {
			type: Object,
			required: !0
		},
		sessionConfig: {
			type: Object,
			default: () => ({ likesConfetti: !1 })
		},
		getViewComponent: {
			type: Function,
			required: !0
		},
		frameless: {
			type: Boolean,
			default: !1
		},
		hideFooter: {
			type: Boolean,
			default: !1
		},
		transitionName: {
			type: String,
			default: "component-fade"
		},
		transitionMode: {
			type: String,
			default: "out-in"
		}
	},
	emits: [
		"session-finished",
		"session-started",
		"card-loaded",
		"card-response",
		"time-changed",
		"session-prepared",
		"session-error",
		"replan-requested"
	],
	data() {
		return {
			cardID: "",
			view: null,
			data: [],
			courseID: "",
			card_elo: 1e3,
			courseNames: {},
			cardCount: 1,
			sessionController: null,
			sessionPrepared: !1,
			sessionFinished: !1,
			sessionRecord: [],
			percentageRemaining: 100,
			timerIsActive: !0,
			loading: !1,
			userCourseRegDoc: null,
			sessionContentSources: [],
			timeRemaining: 300,
			replanPending: !1,
			replanOptions: null,
			deferredNextCardAction: null,
			intervalHandler: null,
			cardType: "",
			debugMode: window.debugMode === !0
		};
	},
	computed: {
		currentCard() {
			return this.sessionRecord[this.sessionRecord.length - 1];
		},
		resolvedTransitionMode() {
			return this.transitionMode === "default" ? void 0 : this.transitionMode;
		}
	},
	async created() {
		this.userCourseRegDoc = await this.user.getCourseRegistrationsDoc(), console.log("[StudySession] Created lifecycle hook - starting initSession"), await this.initSession(), console.log("[StudySession] InitSession completed in created hook");
	},
	errorCaptured(e, t, n) {
		return console.error(`[StudySession] Card render error (${n}), skipping card "${this.cardID}":`, e), this.sessionController && this.sessionController.nextCard().then((e) => this.loadCard(e)), !1;
	},
	methods: {
		async handleReadyToAdvance() {
			let e = this.deferredNextCardAction;
			if (!e) {
				console.warn("[StudySession] ready-to-advance received but no deferred action stashed — ignoring");
				return;
			}
			console.log(`[StudySession] ready-to-advance received — advancing with stashed action: ${e}`), this.deferredNextCardAction = null, this.loadCard(await this.sessionController.nextCard(e));
		},
		handleReplanRequest(e) {
			if (this.sessionController) {
				let t = e?.label, n = t ? ` [${t}]` : "";
				console.log(`[StudySession] Replan requested by card view${n}, deferring until after response processing`), this.replanPending = !0, this.replanOptions = e ?? null;
			}
		},
		user_elo(e) {
			let t = this.userCourseRegDoc.courses.find((t) => t.courseID === e);
			return ge(t ? t.elo : void 0);
		},
		handleClassroomMessage() {
			return (e) => (Z({
				text: this.user?.getUsername() || "[Unknown user]",
				status: J.ok
			}), console.log("[StudySession] There was a change in the classroom DB:"), console.log(`[StudySession] change: ${e}`), console.log(`[StudySession] Stringified change: ${JSON.stringify(e)}`), {});
		},
		incrementSessionClock() {
			let e = 60 * this.sessionTimeLimit - this.timeRemaining;
			this.sessionController.addTime(Math.min(e, 60)), this.tick();
		},
		tick() {
			this.timeRemaining = this.sessionController.secondsRemaining, this.percentageRemaining = this.timeRemaining > 60 ? 100 * (this.timeRemaining / (60 * this.sessionTimeLimit)) : 100 * (this.timeRemaining / 60), this.$emit("time-changed", this.timeRemaining), this.timeRemaining === 0 && clearInterval(this.intervalHandler);
		},
		async initSession() {
			let e = [];
			try {
				console.log(`[StudySession] starting study session w/ sources: ${JSON.stringify(this.contentSources)}`), console.log("[StudySession] Beginning preparation process"), this.sessionContentSources = N((await Promise.all(this.contentSources.map(async (e) => {
					try {
						return await be(e, this.user);
					} catch (t) {
						return console.error(`Failed to load study source: ${e.type}/${e.id}`, t), null;
					}
				}))).filter((e) => e !== null)), this.timeRemaining = this.sessionTimeLimit * 60, e = await Promise.all(this.contentSources.filter((e) => e.type === "classroom").map(async (e) => await this.dataLayer.getClassroomDB(e.id, "student"))), e.forEach((e) => {});
				let t = {};
				this.sessionConfig?.defaultBatchLimit !== void 0 && (t.defaultBatchLimit = this.sessionConfig.defaultBatchLimit), this.sessionConfig?.outcomeObservers?.length && (t.outcomeObservers = this.sessionConfig.outcomeObservers), this.sessionController = N(new ve(this.sessionContentSources, 60 * this.sessionTimeLimit, this.dataLayer, this.getViewComponent, void 0, t)), this.sessionController.sessionRecord = this.sessionRecord, this.sessionConfig?.initHints && (this.sessionController.setSessionHints(this.sessionConfig.initHints), console.log("[StudySession] Applied init hints as session-durable hints")), await this.sessionController.prepareSession(), this.intervalHandler = setInterval(this.tick, 1e3), this.sessionPrepared = !0, console.log("[StudySession] Session preparation complete, emitting session-prepared event"), this.$emit("session-prepared"), console.log("[StudySession] Event emission completed");
			} catch (e) {
				console.error("[StudySession] Error during session preparation:", e), this.$emit("session-error", {
					message: "Failed to prepare study session",
					error: e
				});
			}
			try {
				this.contentSources.filter((e) => e.type === "course").forEach(async (e) => this.courseNames[e.id] = (await this.dataLayer.getCoursesDB().getCourseConfig(e.id)).name), console.log(`[StudySession] Session created:
          ${this.sessionController?.toString() || "Session controller not initialized"}
          User courses: ${this.contentSources.filter((e) => e.type === "course").map((e) => e.id).toString()}
          User classrooms: ${e.map((e) => e._id).toString() || "No classrooms"}
        `);
			} catch (e) {
				console.error("[StudySession] Error during final session setup:", e);
			}
			if (this.sessionController) try {
				this.$emit("session-started"), this.loadCard(await this.sessionController.nextCard());
			} catch (e) {
				console.error("[StudySession] Error loading next card:", e), this.$emit("session-error", {
					message: "Failed to load study card",
					error: e
				});
			}
			else console.error("[StudySession] Cannot load card: session controller not initialized"), this.$emit("session-error", { message: "Study session initialization failed" });
		},
		countCardViews(e, t) {
			return this.sessionRecord.filter((n) => n.card.course_id === e && n.card.card_id === t).length;
		},
		async processResponse(e) {
			this.$emit("card-response", e), this.timerIsActive = !0, e.cardID = this.cardID, e.courseID = this.courseID, this.currentCard.records.push(e), console.log("[StudySession] StudySession.processResponse is running...");
			let t = this.logCardRecord(e).catch((e) => {
				throw console.error("[StudySession] putCardRecord failed:", e), e;
			}), n = 1, r = 1;
			if (o(this.$refs.cardViewer?.$refs.activeView)) {
				let e = this.$refs.cardViewer.$refs.activeView;
				n = e.maxAttemptsPerView, r = e.maxSessionViews;
			}
			let i = this.countCardViews(this.courseID, this.cardID), a = await this.sessionController.submitResponse(e, t, this.userCourseRegDoc, this.currentCard, this.courseID, this.cardID, n, r, i);
			try {
				this.handleUIFeedback(a);
			} catch (e) {
				console.error(`[StudySession] Error handling UI feedback: ${e}.\n\nResult: ${JSON.stringify(a)}`);
			}
			if (this.replanPending) {
				let e = this.replanOptions, t = e?.label, n = t ? ` [${t}]` : "";
				console.log(`[StudySession] Firing deferred replan (post-submitResponse)${n}`), this.replanPending = !1, this.replanOptions = null, this.sessionController.requestReplan(e ?? void 0), this.$emit("replan-requested");
			}
			a.deferred ? (console.log(`[StudySession] Deferred advance — stashing action: ${a.nextCardAction}`), this.deferredNextCardAction = a.nextCardAction) : a.shouldLoadNextCard && this.loadCard(await this.sessionController.nextCard(a.nextCardAction)), a.shouldClearFeedbackShadow && this.clearFeedbackShadow();
		},
		handleUIFeedback(e) {
			if (e.isCorrect) {
				if (!this.frameless) try {
					this.$refs.shadowWrapper && e.performanceScore !== void 0 && (this.$refs.shadowWrapper.setAttribute("style", `--r: ${255 * (1 - e.performanceScore)}; --g:255`), this.$refs.shadowWrapper.classList.add("correct"));
				} catch (e) {
					console.warn(`[StudySession] Error setting shadowWrapper style: ${e}`);
				}
				this.sessionConfig.likesConfetti && Ht({
					origin: {
						y: 1,
						x: .25 + .5 * Math.random()
					},
					disableForReducedMotion: !0,
					angle: 60 + 60 * Math.random()
				});
			} else if (!this.frameless) try {
				this.$refs.shadowWrapper && this.$refs.shadowWrapper.classList.add("incorrect");
			} catch (e) {
				console.warn(`[StudySession] Error setting shadowWrapper style: ${e}`);
			}
		},
		clearFeedbackShadow() {
			this.frameless || setTimeout(() => {
				try {
					this.$refs.shadowWrapper && this.$refs.shadowWrapper.classList.remove("correct", "incorrect");
				} catch (e) {
					console.warn(`[StudySession] Error clearing shadowWrapper style: ${e}`);
				}
			}, 1250);
		},
		async logCardRecord(e) {
			console.log("[StudySession] About to call user.putCardRecord...");
			let t = await this.user.putCardRecord(e);
			return console.log("[StudySession] user.putCardRecord completed"), t;
		},
		async loadCard(e) {
			if (this.loading) {
				console.warn("Attempted to load card while loading another...");
				return;
			}
			if (console.log(`[StudySession] loading: ${JSON.stringify(e)}`), e === null) {
				this.sessionFinished = !0, this.$emit("session-finished", this.sessionRecord);
				return;
			}
			this.cardType = e.item.status, this.loading = !0, this.cardCount++, this.data = e.data, this.view = N(e.view), this.cardID = e.item.cardID, this.courseID = e.item.courseID, this.card_elo = e.item.elo || 1e3, this.sessionRecord.push({
				card: {
					course_id: e.item.courseID,
					card_id: e.item.cardID,
					card_elo: this.card_elo,
					tags: e.tags ?? []
				},
				item: e.item,
				records: []
			}), this.$emit("card-loaded", {
				courseID: e.item.courseID,
				cardID: e.item.cardID,
				cardCount: this.cardCount
			}), this.loading = !1;
		}
	}
}), Wt = {
	key: 0,
	class: "StudySession"
}, Gt = { key: 2 }, Kt = {
	key: 3,
	class: "session-finished-area"
}, qt = { class: "text-h4" }, Jt = { key: 0 }, Yt = {
	key: 4,
	ref: "shadowWrapper",
	class: "card-transition-container"
}, Xt = { key: 0 };
function _sfc_render$15(e, t, n, r, i, a) {
	let o = V("v-spacer"), s = V("v-progress-circular"), c = V("v-row"), l = V("session-controller-debug"), u = V("heat-map"), d = V("card-viewer"), f = V("StudySessionTimer"), p = V("v-col"), m = V("SkMouseTrap");
	return e.sessionPrepared ? (L(), O("div", Wt, [
		e.frameless ? D("", !0) : (L(), E(c, {
			key: 0,
			align: "center"
		}, {
			default: W(() => [j(o), e.loading ? (L(), E(s, {
				key: 0,
				color: "primary",
				indeterminate: "",
				size: "32",
				width: "4"
			})) : D("", !0)]),
			_: 1
		})),
		e.debugMode ? (L(), E(l, {
			key: 1,
			"session-controller": e.sessionController
		}, null, 8, ["session-controller"])) : D("", !0),
		e.frameless ? D("", !0) : (L(), O("br", Gt)),
		e.sessionFinished ? (L(), O("div", Kt, [B(e.$slots, "session-finished", {
			sessionRecord: e.sessionRecord,
			report: e.sessionController?.report
		}, () => [k("div", qt, [
			t[1] || (t[1] = k("p", null, "Study session finished! Great job!", -1)),
			e.sessionController ? (L(), O("p", Jt, H(e.sessionController.report), 1)) : D("", !0),
			j(u, { "activity-records-getter": () => e.user.getActivityRecords() }, null, 8, ["activity-records-getter"])
		])], !0)])) : (L(), O("div", Yt, [j(w, {
			name: e.transitionName,
			mode: e.resolvedTransitionMode
		}, {
			default: W(() => [e.view ? (L(), E(d, {
				ref: "cardViewer",
				key: e.cardID,
				class: F(e.loading ? "muted" : ""),
				view: e.view,
				data: e.data,
				card_id: e.cardID,
				course_id: e.courseID,
				"session-order": e.cardCount,
				user_elo: e.user_elo(e.courseID),
				card_elo: e.card_elo,
				frameless: e.frameless,
				onEmitResponse: t[0] || (t[0] = (t) => e.processResponse(t)),
				onRequestReplan: e.handleReplanRequest,
				onReadyToAdvance: e.handleReadyToAdvance
			}, null, 8, [
				"class",
				"view",
				"data",
				"card_id",
				"course_id",
				"session-order",
				"user_elo",
				"card_elo",
				"frameless",
				"onRequestReplan",
				"onReadyToAdvance"
			])) : D("", !0)]),
			_: 1
		}, 8, ["name", "mode"])], 512)),
		e.frameless ? D("", !0) : (L(), O(C, { key: 5 }, [t[2] || (t[2] = k("br", null, null, -1)), e.sessionController ? (L(), O("div", Xt, [(L(!0), O(C, null, z(e.sessionController.failedCount, (e) => (L(), O("span", {
			key: e,
			class: "text-h5"
		}, "•"))), 128))])) : D("", !0)], 64)),
		e.hideFooter ? D("", !0) : (L(), E(c, {
			key: 6,
			align: "center",
			class: "footer-controls pa-5"
		}, {
			default: W(() => [
				j(p, {
					cols: "auto",
					class: "d-flex flex-grow-0 mr-auto"
				}, {
					default: W(() => [j(f, {
						"time-remaining": e.timeRemaining,
						"session-time-limit": e.sessionTimeLimit,
						onAddTime: e.incrementSessionClock
					}, null, 8, [
						"time-remaining",
						"session-time-limit",
						"onAddTime"
					])]),
					_: 1
				}),
				j(o),
				j(p, {
					cols: "auto",
					class: "footer-right"
				}, {
					default: W(() => [j(m)]),
					_: 1
				})
			]),
			_: 1
		}))
	])) : D("", !0);
}
t(_sfc_render$15, "_sfc_render");
var Zt = /* @__PURE__ */ r(Ut, [["render", _sfc_render$15], ["__scopeId", "data-v-d6d88dad"]]), Qt = M({
	name: "MultipleChoiceOption",
	components: { MarkdownRenderer: re(() => import("./MarkdownRenderer-kStoDRNE.mjs").then((e) => e.n)) },
	props: {
		content: {
			type: String,
			required: !0
		},
		selected: {
			type: Boolean,
			required: !0
		},
		number: {
			type: Number,
			required: !0
		},
		setSelection: {
			type: Function,
			required: !0
		},
		submit: {
			type: Function,
			required: !0
		},
		markedWrong: {
			type: Boolean,
			required: !0
		}
	},
	computed: { className() {
		let e;
		switch (this.number) {
			case 0:
				e = "bg-red";
				break;
			case 1:
				e = "bg-purple";
				break;
			case 2:
				e = "bg-indigo";
				break;
			case 3:
				e = "bg-light-blue";
				break;
			case 4:
				e = "bg-teal";
				break;
			case 5:
				e = "bg-deep-orange";
				break;
			default:
				e = "bg-grey";
				break;
		}
		if (this.selected && !this.markedWrong) return `choice selected ${e} lighten-3 elevation-8`;
		if (!this.selected && !this.markedWrong) return `choice not-selected ${e} lighten-4 elevation-1`;
		if (this.selected && this.markedWrong) return "choice selected grey lighten-2 elevation-8";
		if (!this.selected && this.markedWrong) return "choice not-selected grey lighten-2 elevation-0";
		throw Error("'selected' and 'markedWrong' props in MultipleChoiceOption are in an impossible configuration.");
	} },
	methods: {
		select() {
			this.setSelection(this.number);
		},
		submitThisOption() {
			this.markedWrong || (this.select(), this.submit());
		}
	}
});
//#endregion
//#region src/components/studentInputs/MultipleChoiceOption.vue
function _sfc_render$14(e, t, n, r, i, a) {
	let o = V("markdown-renderer"), s = V("v-card");
	return L(), E(s, {
		class: F(`${e.className}`),
		onMouseover: e.select,
		onClick: e.submitThisOption
	}, {
		default: W(() => [j(o, { md: e.content }, null, 8, ["md"])]),
		_: 1
	}, 8, [
		"class",
		"onMouseover",
		"onClick"
	]);
}
t(_sfc_render$14, "_sfc_render");
var $t = /* @__PURE__ */ r(Qt, [["render", _sfc_render$14], ["__scopeId", "data-v-96de7172"]]), en = M({
	name: "RadioMultipleChoice",
	components: { MultipleChoiceOption: $t },
	extends: u,
	props: { choiceList: {
		type: Array,
		required: !0
	} },
	data() {
		return {
			currentSelection: -1,
			incorrectSelections: [],
			containerRef: null,
			_registeredHotkeys: []
		};
	},
	watch: { choiceList: {
		immediate: !0,
		handler(e) {
			e?.length && this.bindKeys();
		}
	} },
	mounted() {
		this.containerRef && this.containerRef.focus();
	},
	unmounted() {
		this.unbindKeys();
	},
	methods: {
		forwardSelection() {
			if (!this.choiceIsWrong(this.choiceList[this.currentSelection]) && this.currentSelection !== -1) {
				let e = {
					choiceList: this.choiceList,
					selection: this.currentSelection
				};
				this.submitAnswer(e).isCorrect || this.incorrectSelections.push(this.currentSelection);
			}
		},
		setSelection(e) {
			e < this.choiceList.length && (this.currentSelection = e);
		},
		incrementSelection() {
			this.currentSelection === -1 ? this.currentSelection = Math.ceil(this.choiceList.length / 2) : this.currentSelection = Math.min(this.choiceList.length - 1, this.currentSelection + 1);
		},
		decrementSelection() {
			this.currentSelection === -1 ? this.currentSelection = Math.floor(this.choiceList.length / 2 - 1) : this.currentSelection = Math.max(0, this.currentSelection - 1);
		},
		choiceIsWrong(e) {
			let t = !1;
			return this.incorrectSelections.forEach((n) => {
				this.choiceList[n] === e && (t = !0);
			}), t;
		},
		bindKeys() {
			let t = [
				{
					hotkey: "left",
					callback: this.decrementSelection,
					command: "Move selection left"
				},
				{
					hotkey: "right",
					callback: this.incrementSelection,
					command: "Move selection right"
				},
				{
					hotkey: "enter",
					callback: this.forwardSelection,
					command: "Submit selection"
				},
				...Array.from({ length: this.choiceList.length }, (e, t) => ({
					hotkey: (t + 1).toString(),
					callback: () => this.setSelection(t),
					command: `Select ${((e) => {
						switch (e) {
							case 0: return "first";
							case 1: return "second";
							case 2: return "third";
							case 3: return "fourth";
							case 4: return "fifth";
							case 5: return "sixth";
							default: return `${e + 1}th`;
						}
					})(t)} option`
				}))
			];
			e.addBinding(t), this._registeredHotkeys = t.map((e) => e.hotkey);
		},
		unbindKeys() {
			this._registeredHotkeys && this._registeredHotkeys.forEach((t) => {
				e.removeBinding(t);
			});
		}
	}
}), tn = {
	ref: "containerRef",
	class: "multipleChoice"
};
function _sfc_render$13(e, t, n, r, i, a) {
	let o = V("MultipleChoiceOption");
	return L(), O("div", tn, [(L(!0), O(C, null, z(e.choiceList, (t, n) => (L(), E(o, {
		key: n,
		content: t,
		selected: e.choiceList.indexOf(t) === e.currentSelection,
		number: e.choiceList.indexOf(t),
		"set-selection": e.setSelection,
		submit: e.forwardSelection,
		"marked-wrong": e.choiceIsWrong(t)
	}, null, 8, [
		"content",
		"selected",
		"number",
		"set-selection",
		"submit",
		"marked-wrong"
	]))), 128))], 512);
}
t(_sfc_render$13, "_sfc_render");
var nn = /* @__PURE__ */ r(en, [["render", _sfc_render$13]]), rn = M({
	name: "TrueFalse",
	components: { RadioMultipleChoice: nn },
	props: {
		MouseTrap: {
			type: Object,
			required: !0
		},
		submit: {
			type: Function,
			required: !0
		}
	}
}), an = { "data-viewable": "TrueFalse" };
function _sfc_render$12(e, t, n, r, i, a) {
	let o = V("RadioMultipleChoice");
	return L(), O("div", an, [j(o, {
		"choice-list": ["True", "False"],
		MouseTrap: e.MouseTrap,
		submit: e.submit
	}, null, 8, ["MouseTrap", "submit"])]);
}
t(_sfc_render$12, "_sfc_render");
var on = /* @__PURE__ */ r(rn, [["render", _sfc_render$12]]), sn = M({
	name: "UserInputNumber",
	ref: {},
	extends: u,
	methods: {
		mounted() {
			this.$refs.input.focus();
		},
		isNumeric(e) {
			return !isNaN(Number.parseFloat(e));
		},
		makeNumeric(e) {
			if (typeof e == "string") return Number.parseFloat(e);
			throw Error("Expected a string, got " + typeof e);
		}
	}
});
//#endregion
//#region src/components/studentInputs/UserInputNumber.vue
function _sfc_render$11(e, t, n, r, i, a) {
	let o = V("v-text-field"), s = V("v-container");
	return L(), E(s, { class: "pa-0" }, {
		default: W(() => [j(o, {
			ref: "input",
			modelValue: e.answer,
			"onUpdate:modelValue": t[0] || (t[0] = (t) => e.answer = t),
			"prepend-icon": "edit",
			autofocus: e.autofocus,
			"row-height": "24",
			"toggle-keys": "[13,32]",
			class: "text-h5",
			rules: [e.isNumeric],
			onKeyup: t[1] || (t[1] = G((t) => e.submitAnswer(e.makeNumeric(e.answer)), ["enter"]))
		}, null, 8, [
			"modelValue",
			"autofocus",
			"rules"
		])]),
		_: 1
	});
}
t(_sfc_render$11, "_sfc_render");
var cn = /* @__PURE__ */ r(sn, [["render", _sfc_render$11], ["__scopeId", "data-v-a56dcd1c"]]), ln = M({
	name: "CardLoader",
	components: { CardViewer: Q },
	props: {
		sessionOrder: {
			type: Number,
			required: !1,
			default: 0
		},
		qualified_id: {
			type: Object,
			required: !0
		},
		viewLookup: {
			type: Function,
			required: !0
		}
	},
	data() {
		return {
			loading: !0,
			view: null,
			data: [],
			courseID: "",
			cardID: ""
		};
	},
	created() {
		this.loadCard();
	},
	watch: { qualified_id: {
		immediate: !0,
		handler() {
			this.loadCard();
		}
	} },
	methods: {
		processResponse(e) {
			Y(`
        Card was displayed at ${e.timeStamp}
        User spent ${e.timeSpent} milliseconds with the card.
      `), this.$emit("emitResponse", e);
		},
		async loadCard() {
			let e = this.qualified_id;
			console.log(`Card Loader displaying: ${e.courseID}::${e.cardID}`), this.loading = !0;
			let t = e.courseID, n = e.cardID, r = X().getCourseDB(t);
			try {
				let e = await r.getCourseDoc(n), i = this.viewLookup(e.id_view), a = e.id_displayable_data.map((e) => r.getCourseDoc(e, {
					attachments: !0,
					binary: !0
				})), o = [];
				for (let e of a) {
					let t = await e;
					o.unshift(pe(t));
				}
				this.data = o, this.view = N(i), this.cardID = n, this.courseID = t;
			} catch (e) {
				throw Error(`[CardLoader] Error loading card: ${JSON.stringify(e)}, ${e}`);
			} finally {
				this.loading = !1, this.$emit("card-loaded");
			}
		}
	}
});
//#endregion
//#region src/components/cardRendering/CardLoader.vue
function _sfc_render$10(e, t, n, r, i, a) {
	let o = V("card-viewer");
	return e.loading ? D("", !0) : (L(), E(o, {
		key: 0,
		class: F(["ma-2", e.loading ? "muted" : ""]),
		view: e.view,
		data: e.data,
		card_id: e.cardID,
		course_id: e.courseID,
		"session-order": e.sessionOrder,
		onEmitResponse: t[0] || (t[0] = (t) => e.processResponse(t))
	}, null, 8, [
		"class",
		"view",
		"data",
		"card_id",
		"course_id",
		"session-order"
	]));
}
t(_sfc_render$10, "_sfc_render");
var un = /* @__PURE__ */ r(ln, [["render", _sfc_render$10], ["__scopeId", "data-v-93f758b5"]]);
//#endregion
//#region src/stores/useAuthStore.ts
async function getCurrentUser() {
	let e = useAuthStore();
	if (!e.onLoadComplete) {
		let t = 200;
		for (; !e.onLoadComplete && t > 0;) await new Promise((e) => setTimeout(e, 50)), t--;
		if (!e.onLoadComplete) throw Error("User initialization timed out");
	}
	return X().getUserDB();
}
var useAuthStore = () => {
	let e = x();
	return e && Se(e), xe("auth", {
		state: () => ({
			_user: void 0,
			loginAndRegistration: {
				init: !1,
				loggedIn: !1,
				regDialogOpen: !1,
				loginDialogOpen: !1
			},
			onLoadComplete: !1
		}),
		actions: {
			async init() {
				try {
					this._user = X().getUserDB(), this.loginAndRegistration.loggedIn = this._user ? this._user.isLoggedIn() : !1, this.onLoadComplete = !0, this.loginAndRegistration.init = !0;
				} catch (e) {
					console.error("Failed to initialize auth store:", e), this.loginAndRegistration.loggedIn = !1, this.onLoadComplete = !0, this.loginAndRegistration.init = !0;
				}
			},
			setLoginDialog(e) {
				this.loginAndRegistration.loginDialogOpen = e;
			},
			setRegDialog(e) {
				this.loginAndRegistration.regDialogOpen = e;
			},
			async resetUserData() {
				try {
					if (!this._user) throw Error("No user available for data reset");
					let e = await this._user.resetUserData();
					if (e.status !== "ok") throw Error(e.error || "Reset failed");
					return console.log("User data reset successfully"), e;
				} catch (e) {
					throw console.error("Failed to reset user data:", e), e;
				}
			}
		},
		getters: {
			currentUser: async () => getCurrentUser(),
			isLoggedIn: (e) => e.loginAndRegistration.loggedIn,
			isInitialized: (e) => e.loginAndRegistration.init,
			status: (e) => ({
				loggedIn: e.loginAndRegistration.loggedIn,
				init: e.loginAndRegistration.init,
				user: e._user
			})
		}
	})();
}, useConfigStore = () => {
	let e = x();
	return e && Se(e), xe("config", {
		state: () => ({ config: {
			darkMode: !1,
			likesConfetti: !1,
			sessionTimeLimit: 5
		} }),
		actions: {
			updateConfig(e) {
				this.config = e;
			},
			async updateDarkMode(e) {
				this.config.darkMode = e;
				let t = await getCurrentUser();
				t && await t.setConfig({ darkMode: e });
			},
			async updateLikesConfetti(e) {
				this.config.likesConfetti = e;
				let t = await getCurrentUser();
				t && await t.setConfig({ likesConfetti: e });
			},
			async updateSessionTimeLimit(e) {
				this.config.sessionTimeLimit = e;
				let t = await getCurrentUser();
				t && await t.setConfig({ sessionTimeLimit: e });
			},
			async hydrate() {
				try {
					let e = await getCurrentUser();
					if (e) {
						let t = await e.getConfig();
						console.log(`user config: ${JSON.stringify(t)}`), this.updateConfig(t);
					} else console.log("No user logged in, using default config");
				} catch (e) {
					console.warn("Failed to hydrate config store, using defaults:", e);
				}
			},
			async init() {
				await this.hydrate();
			},
			resetDefaults() {
				this.config = {
					darkMode: !1,
					likesConfetti: !1,
					sessionTimeLimit: 5
				};
			}
		}
	})();
};
//#endregion
//#region src/composables/useAuthUI.ts
function useAuthUI() {
	let e = R(!0), t = R(!1), n = R(!1), r = T(() => n.value ? {
		showLoginRegistration: !1,
		showLogout: !1,
		showResetData: !0,
		logoutLabel: "",
		resetLabel: "Reset User Data"
	} : {
		showLoginRegistration: !0,
		showLogout: !0,
		showResetData: !1,
		logoutLabel: "Log out",
		resetLabel: ""
	}), detectSyncStrategy = async () => {
		try {
			e.value = !0, n.value = !(await getCurrentUser()).syncStrategy?.canCreateAccount?.(), t.value = !0;
		} catch (e) {
			console.error("Failed to detect sync strategy:", e), n.value = !1, t.value = !0;
		} finally {
			e.value = !1;
		}
	};
	return {
		config: r,
		isLoading: e,
		syncStrategyDetected: t,
		isLocalOnlyMode: n,
		detectSyncStrategy
	};
}
//#endregion
//#region src/components/auth/UserChip.vue
var dn = /* @__PURE__ */ r(/* @__PURE__ */ M({
	__name: "UserChip",
	props: {
		showLoginButton: { type: Boolean },
		redirectToPath: {}
	},
	setup(e) {
		let t = we(), n = useAuthStore(), r = useConfigStore(), i = useAuthUI(), a = R(""), o = R([]), s = R(!1), c = R(""), l = T(() => c.value === "reset"), resetDialogState = () => {
			c.value = "", s.value = !1;
		}, u = T(() => o.value.length > 0), d = T(() => i.config.value || {
			showLoginRegistration: !0,
			showLogout: !0,
			showResetData: !1,
			logoutLabel: "Log out",
			resetLabel: ""
		});
		I(async () => {
			a.value = (await getCurrentUser()).getUsername(), await i.detectSyncStrategy();
		});
		let gotoSettings = async () => {
			t.push(`/u/${(await getCurrentUser()).getUsername()}`);
		}, gotoStats = async () => {
			t.push(`/u/${(await getCurrentUser()).getUsername()}/stats`);
		}, dismiss = (e) => {
			let t = o.value.indexOf(e);
			o.value.splice(t, 1);
		}, logout = async () => {
			(await n._user.logout()).ok && (n.loginAndRegistration = {
				init: !0,
				loggedIn: !1,
				regDialogOpen: !1,
				loginDialogOpen: !1
			}, r.resetDefaults(), t.push("/home"));
		}, executeReset = async () => {
			try {
				await n.resetUserData(), r.resetDefaults(), resetDialogState(), t.push("/home");
			} catch (e) {
				console.error("Failed to reset user data:", e);
			}
		};
		return (e, t) => {
			let n = V("v-icon"), r = V("v-avatar"), i = V("v-chip"), f = V("v-list-item-title"), p = V("v-list-item"), m = V("v-divider"), h = V("v-list"), g = V("v-menu"), _ = V("v-badge"), v = V("v-card-title"), y = V("v-text-field"), b = V("v-card-text"), x = V("v-spacer"), S = V("v-btn"), ee = V("v-card-actions"), te = V("v-card"), w = V("v-dialog");
			return L(), O(C, null, [j(_, {
				content: o.value.length,
				"model-value": u.value,
				color: "accent",
				location: "end top"
			}, {
				default: W(() => [j(g, {
					location: "bottom end",
					transition: "scale-transition"
				}, {
					activator: W(({ props: e }) => [j(i, P(e, { class: "ma-2" }), {
						default: W(() => [j(r, {
							start: "",
							class: "bg-primary"
						}, {
							default: W(() => [j(n, null, {
								default: W(() => t[4] || (t[4] = [A("mdi-school")])),
								_: 1
							})]),
							_: 1
						}), A(" " + H(a.value), 1)]),
						_: 2
					}, 1040)]),
					default: W(() => [j(h, null, {
						default: W(() => [
							(L(!0), O(C, null, z(o.value, (e) => (L(), E(p, {
								key: e,
								onClick: (t) => dismiss(e)
							}, {
								default: W(() => [j(f, null, {
									default: W(() => [A(H(e), 1)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, ["onClick"]))), 128)),
							o.value.length ? (L(), E(m, { key: 0 })) : D("", !0),
							j(p, { onClick: gotoStats }, {
								prepend: W(() => [j(n, null, {
									default: W(() => t[5] || (t[5] = [A("mdi-trending-up")])),
									_: 1
								})]),
								default: W(() => [j(f, null, {
									default: W(() => t[6] || (t[6] = [A("Stats")])),
									_: 1
								})]),
								_: 1
							}),
							j(p, { onClick: gotoSettings }, {
								prepend: W(() => [j(n, null, {
									default: W(() => t[7] || (t[7] = [A("mdi-cog")])),
									_: 1
								})]),
								default: W(() => [j(f, null, {
									default: W(() => t[8] || (t[8] = [A("Settings")])),
									_: 1
								})]),
								_: 1
							}),
							d.value.showLogout ? (L(), E(p, {
								key: 1,
								onClick: logout
							}, {
								prepend: W(() => [j(n, null, {
									default: W(() => t[9] || (t[9] = [A("mdi-logout")])),
									_: 1
								})]),
								default: W(() => [j(f, null, {
									default: W(() => [A(H(d.value.logoutLabel), 1)]),
									_: 1
								})]),
								_: 1
							})) : D("", !0),
							d.value.showResetData ? (L(), E(p, {
								key: 2,
								onClick: t[0] || (t[0] = (e) => s.value = !0)
							}, {
								prepend: W(() => [j(n, null, {
									default: W(() => t[10] || (t[10] = [A("mdi-delete-sweep")])),
									_: 1
								})]),
								default: W(() => [j(f, null, {
									default: W(() => [A(H(d.value.resetLabel), 1)]),
									_: 1
								})]),
								_: 1
							})) : D("", !0)
						]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			}, 8, ["content", "model-value"]), j(w, {
				modelValue: s.value,
				"onUpdate:modelValue": t[3] || (t[3] = (e) => s.value = e),
				"max-width": "500px",
				persistent: ""
			}, {
				default: W(() => [j(te, null, {
					default: W(() => [
						j(v, { class: "text-h5 d-flex align-center" }, {
							default: W(() => [j(n, {
								color: "warning",
								class: "mr-3"
							}, {
								default: W(() => t[11] || (t[11] = [A("mdi-alert-circle")])),
								_: 1
							}), t[12] || (t[12] = A(" Reset All User Data "))]),
							_: 1
						}),
						j(b, null, {
							default: W(() => [
								t[13] || (t[13] = k("p", { class: "mb-4" }, "This will permanently delete:", -1)),
								t[14] || (t[14] = k("ul", { class: "mb-4" }, [
									k("li", null, "All course progress and history"),
									k("li", null, "Scheduled card reviews"),
									k("li", null, "Course registrations"),
									k("li", null, "User preferences")
								], -1)),
								t[15] || (t[15] = k("p", { class: "mb-4 text-error font-weight-bold" }, "This cannot be undone.", -1)),
								j(y, {
									modelValue: c.value,
									"onUpdate:modelValue": t[1] || (t[1] = (e) => c.value = e),
									label: "Type \"reset\" to confirm",
									outlined: "",
									dense: "",
									onKeyup: t[2] || (t[2] = G((e) => l.value && executeReset(), ["enter"]))
								}, null, 8, ["modelValue"])
							]),
							_: 1
						}),
						j(ee, null, {
							default: W(() => [
								j(x),
								j(S, {
									text: "",
									onClick: resetDialogState
								}, {
									default: W(() => t[16] || (t[16] = [A("Cancel")])),
									_: 1
								}),
								j(S, {
									color: "error",
									disabled: !l.value,
									onClick: executeReset
								}, {
									default: W(() => t[17] || (t[17] = [A(" Reset All Data ")])),
									_: 1
								}, 8, ["disabled"])
							]),
							_: 1
						})
					]),
					_: 1
				})]),
				_: 1
			}, 8, ["modelValue"])], 64);
		};
	}
}), [["__scopeId", "data-v-9a38a213"]]), fn = { class: "d-flex flex-column align-start" }, pn = { class: "mb-2" }, mn = /* @__PURE__ */ r(/* @__PURE__ */ M({
	__name: "UserLogin",
	props: { redirectTo: { default: "/study" } },
	emits: [
		"toggle",
		"loginSuccess",
		"forgotPassword"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = we(), a = Ce(), o = useAuthStore(), s = useConfigStore(), c = R(""), l = R(""), u = R(!1), d = R(!1), f = R(!1), p = R(7e3), m = R(void 0), h = T(() => a.name === "login"), g = T(() => ({
			color: f.value ? "error" : "success",
			text: f.value ? "Try again" : "Log In"
		})), initBadLogin = () => {
			f.value = !0, Z({
				text: "Username or password was incorrect.",
				status: J.error,
				timeout: p.value
			}), setTimeout(() => {
				f.value = !1;
			}, p.value);
		}, login = async () => {
			d.value = !0, Y("Starting login attempt"), Y(`Login attempt for username: ${c.value}`);
			try {
				Y("Attempting to get User instance"), m.value = await getCurrentUser(), Y("Got User instance, attempting login"), await m.value.login(c.value, l.value), Y("Login successful"), Y("Initializing user config"), s.init(), Y("User config initialized"), Y("Setting authentication state"), o.loginAndRegistration.loggedIn = !0, Y(`Authentication state set, redirecting to: ${n.redirectTo}`), r("loginSuccess", n.redirectTo), i.push(n.redirectTo), Y("Login and redirect complete");
			} catch (e) {
				Y("Login attempt failed"), Y(`Login error details: ${JSON.stringify(e)}`), console.log(`login error: ${JSON.stringify(e)}`), Y("Initiating bad login feedback"), initBadLogin();
			}
			Y("Resetting awaiting response state"), d.value = !1;
		}, toggle = () => {
			Y("Toggling registration / login forms."), r("toggle");
		}, handleForgotPassword = () => {
			Y("Forgot password clicked"), h.value ? i.push("/request-reset") : r("forgotPassword");
		};
		return (e, t) => {
			let n = V("v-card-title"), r = V("v-text-field"), i = V("v-btn"), a = V("v-snackbar"), o = V("v-icon"), s = V("router-link"), m = V("v-form"), _ = V("v-card-text"), v = V("v-card");
			return L(), E(v, null, {
				default: W(() => [h.value ? D("", !0) : (L(), E(n, {
					key: 0,
					class: "text-h5 bg-grey-lighten-2"
				}, {
					default: W(() => t[5] || (t[5] = [A("Log In")])),
					_: 1
				})), j(_, null, {
					default: W(() => [j(m, {
						onsubmit: "return false;",
						onSubmit: K(login, ["prevent"])
					}, {
						default: W(() => [
							j(r, {
								id: "",
								modelValue: c.value,
								"onUpdate:modelValue": t[0] || (t[0] = (e) => c.value = e),
								autofocus: "",
								name: "username",
								label: "Username",
								"prepend-icon": "mdi-account-circle"
							}, null, 8, ["modelValue"]),
							j(r, {
								modelValue: l.value,
								"onUpdate:modelValue": t[1] || (t[1] = (e) => l.value = e),
								"prepend-icon": "mdi-lock",
								name: "password",
								hover: "Show password input",
								label: "Enter your password",
								hint: "",
								min: "0",
								"append-icon": u.value ? "mdi-eye-off" : "mdi-eye",
								type: u.value ? "text" : "password",
								"onClick:append": t[2] || (t[2] = () => u.value = !u.value)
							}, null, 8, [
								"modelValue",
								"append-icon",
								"type"
							]),
							j(a, {
								modelValue: f.value,
								"onUpdate:modelValue": t[4] || (t[4] = (e) => f.value = e),
								location: "bottom right",
								timeout: p.value
							}, {
								default: W(() => [t[7] || (t[7] = A(" Username or password was incorrect. ")), j(i, {
									color: "pink",
									variant: "text",
									onClick: t[3] || (t[3] = (e) => f.value = !1)
								}, {
									default: W(() => t[6] || (t[6] = [A("Close")])),
									_: 1
								})]),
								_: 1
							}, 8, ["modelValue", "timeout"]),
							k("div", fn, [k("div", pn, [j(i, {
								class: "mr-2",
								type: "submit",
								loading: d.value,
								color: g.value.color
							}, {
								default: W(() => [j(o, { start: "" }, {
									default: W(() => t[8] || (t[8] = [A("mdi-lock-open")])),
									_: 1
								}), t[9] || (t[9] = A(" Log In "))]),
								_: 1
							}, 8, ["loading", "color"]), h.value ? (L(), E(s, {
								key: 0,
								to: "signup"
							}, {
								default: W(() => [j(i, { variant: "text" }, {
									default: W(() => t[10] || (t[10] = [A("Create New Account")])),
									_: 1
								})]),
								_: 1
							})) : (L(), E(i, {
								key: 1,
								variant: "text",
								onClick: toggle
							}, {
								default: W(() => t[11] || (t[11] = [A("Create New Account")])),
								_: 1
							}))]), B(e.$slots, "forgot-password", {}, () => [k("a", {
								href: "#",
								class: "text-caption text-decoration-none",
								onClick: K(handleForgotPassword, ["prevent"])
							}, " Forgot password? ")], !0)])
						]),
						_: 3
					})]),
					_: 3
				})]),
				_: 3
			});
		};
	}
}), [["__scopeId", "data-v-563b0048"]]);
//#endregion
//#region src/utils/passwordValidation.ts
function validatePassword(e) {
	return e ? e.length < 6 ? "Password must be at least 6 characters" : new Set(e).size < 2 ? "Password must contain at least 2 different characters" : "" : "";
}
function isPasswordValid(e) {
	return validatePassword(e) === "";
}
//#endregion
//#region src/components/auth/UserRegistration.vue?vue&type=script&lang.ts
var hn = M({
	name: "UserRegistration",
	props: { onSignupSuccess: {
		type: Function,
		required: !1
	} },
	emits: ["toggle", "signup-success"],
	data() {
		return {
			email: "",
			username: "",
			password: "",
			retypedPassword: "",
			passwordVisible: !1,
			emailError: !1,
			emailHint: "",
			usernameValidationInProgress: !1,
			usernameError: !1,
			usernameHint: "",
			awaitingResponse: !1,
			badLoginAttempt: !1,
			userSecret: "",
			secret: "goons",
			user: null,
			roles: [
				"Student",
				"Teacher",
				"Author"
			],
			student: !0,
			teacher: !1,
			author: !1,
			authStore: useAuthStore()
		};
	},
	computed: {
		registrationRoute() {
			return typeof this.$route.name == "string" && this.$route.name.toLowerCase() === "signup";
		},
		buttonStatus() {
			return {
				color: this.badLoginAttempt ? "error" : "success",
				text: this.badLoginAttempt ? "Try again" : "Log In"
			};
		},
		passwordError() {
			return validatePassword(this.password);
		},
		passwordRetypeError() {
			return console.log("[RTE]"), this.password === this.retypedPassword ? "" : "Passwords must match.";
		}
	},
	async created() {
		this.user = await getCurrentUser();
	},
	methods: {
		toggle() {
			Y("Toggling registration / login forms."), this.$emit("toggle");
		},
		validateEmail() {
			this.emailError = !1, this.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email) ? (this.emailError = !0, this.emailHint = "Please enter a valid email address") : this.emailHint = "";
		},
		validateUsername() {
			this.usernameError = !1;
		},
		async createUser() {
			if (this.awaitingResponse = !0, this.passwordError) {
				Z({
					text: this.passwordError,
					status: J.error
				}), this.awaitingResponse = !1;
				return;
			}
			if (Y(`
User creation
-------------

Name: ${this.username}
Student: ${this.student}
Teacher: ${this.teacher}
Author: ${this.author}
`), this.password === this.retypedPassword) {
				if (!this.user) {
					console.error("ERROR: No user object available");
					return;
				}
				this.user.createAccount(this.username, this.password).then(async (e) => {
					if (e.status === J.ok) {
						if (this.authStore.loginAndRegistration.loggedIn = !0, this.authStore.loginAndRegistration.init = !1, this.authStore.loginAndRegistration.init = !0, this.email) try {
							await (await getCurrentUser()).setConfig({ email: this.email });
							let e = typeof window < "u" ? window.location.origin : void 0, t = await sendVerificationEmail(this.username, this.email, e);
							t.ok ? Z({
								text: "Account created! Please check your email to verify your account.",
								status: J.ok
							}) : Y(`Warning: Failed to send verification email: ${t.error}`);
						} catch (e) {
							console.error("Email save/send error:", e), Y(`Warning: Failed to save email or send verification: ${e}`);
						}
						this.onSignupSuccess && (console.log("[UserRegistration] Calling onSignupSuccess callback"), this.onSignupSuccess({ username: this.username })), this.$emit("signup-success", { username: this.username });
					} else e.error === "This username is taken!" ? (this.usernameError = !0, this.usernameHint = "Try a different name.", this.$refs.userNameTextField.focus(), Z({
						text: `The name ${this.username} is taken!`,
						status: e.status
					})) : Z({
						text: e.error,
						status: e.status
					});
				}).catch((e) => {
					console.error("[UserRegistration] .catch() called with error:", e), e && Z({
						text: e?.message || e?.error || e?.toString() || "Account creation failed",
						status: J.error
					});
				}), this.awaitingResponse = !1;
			} else Z({
				text: "Passwords do not match.",
				status: J.error
			}), this.awaitingResponse = !1;
		}
	}
});
//#endregion
//#region src/components/auth/UserRegistration.vue
function _sfc_render$9(e, t, n, r, i, a) {
	let o = V("v-card-title"), s = V("v-text-field"), c = V("v-btn"), l = V("v-snackbar"), u = V("v-icon"), d = V("router-link"), f = V("v-form"), p = V("v-card-text"), m = V("v-card");
	return L(), E(m, null, {
		default: W(() => [j(o, { class: "text-h5 bg-grey-lighten-2" }, {
			default: W(() => t[7] || (t[7] = [A(" Create an Account ")])),
			_: 1
		}), j(p, null, {
			default: W(() => [j(f, { onSubmit: K(e.createUser, ["prevent"]) }, {
				default: W(() => [
					j(s, {
						modelValue: e.email,
						"onUpdate:modelValue": t[0] || (t[0] = (t) => e.email = t),
						name: "email",
						label: "Email address",
						type: "email",
						"prepend-icon": "mdi-email",
						error: e.emailError,
						hint: e.emailHint,
						onBlur: e.validateEmail
					}, null, 8, [
						"modelValue",
						"error",
						"hint",
						"onBlur"
					]),
					j(s, {
						id: "",
						ref: "userNameTextField",
						modelValue: e.username,
						"onUpdate:modelValue": t[1] || (t[1] = (t) => e.username = t),
						name: "username",
						label: "Choose a Username",
						"prepend-icon": "mdi-account-circle",
						error: e.usernameError,
						hint: e.usernameHint,
						onBlur: e.validateUsername
					}, null, 8, [
						"modelValue",
						"error",
						"hint",
						"onBlur"
					]),
					j(s, {
						modelValue: e.password,
						"onUpdate:modelValue": t[2] || (t[2] = (t) => e.password = t),
						"prepend-icon": "mdi-lock",
						name: "password",
						hover: "Show password",
						label: "Create a password",
						hint: e.passwordError,
						error: !!e.passwordError,
						min: "4",
						"append-icon": e.passwordVisible ? "mdi-eye-off" : "mdi-eye",
						type: e.passwordVisible ? "text" : "password",
						"onClick:append": t[3] || (t[3] = () => e.passwordVisible = !e.passwordVisible)
					}, null, 8, [
						"modelValue",
						"hint",
						"error",
						"append-icon",
						"type"
					]),
					j(s, {
						modelValue: e.retypedPassword,
						"onUpdate:modelValue": t[4] || (t[4] = (t) => e.retypedPassword = t),
						"prepend-icon": "mdi-lock",
						name: "retypedPassword",
						hover: "Show password",
						label: "Retype your password",
						disabled: e.password === "" || !!e.passwordError,
						hint: e.passwordRetypeError,
						min: "4",
						type: e.passwordVisible ? "text" : "password"
					}, null, 8, [
						"modelValue",
						"disabled",
						"hint",
						"type"
					]),
					j(l, {
						modelValue: e.badLoginAttempt,
						"onUpdate:modelValue": t[6] || (t[6] = (t) => e.badLoginAttempt = t),
						location: "bottom right",
						timeout: 5e3
					}, {
						default: W(() => [t[9] || (t[9] = A(" Username or password was incorrect. ")), j(c, {
							color: "pink",
							variant: "text",
							onClick: t[5] || (t[5] = (t) => e.badLoginAttempt = !1)
						}, {
							default: W(() => t[8] || (t[8] = [A(" Close ")])),
							_: 1
						})]),
						_: 1
					}, 8, ["modelValue"]),
					j(c, {
						class: "mr-2 my-2",
						type: "submit",
						loading: e.awaitingResponse,
						color: e.buttonStatus.color,
						disabled: !!e.passwordError || e.password !== e.retypedPassword
					}, {
						default: W(() => [j(u, { start: "" }, {
							default: W(() => t[10] || (t[10] = [A("mdi-lock-open")])),
							_: 1
						}), t[11] || (t[11] = A(" Create Account "))]),
						_: 1
					}, 8, [
						"loading",
						"color",
						"disabled"
					]),
					e.registrationRoute ? (L(), E(d, {
						key: 0,
						to: "login"
					}, {
						default: W(() => [j(c, { variant: "text" }, {
							default: W(() => t[12] || (t[12] = [A("Log In")])),
							_: 1
						})]),
						_: 1
					})) : (L(), E(c, {
						key: 1,
						variant: "text",
						onClick: e.toggle
					}, {
						default: W(() => t[13] || (t[13] = [A(" Log In ")])),
						_: 1
					}, 8, ["onClick"]))
				]),
				_: 1
			}, 8, ["onSubmit"])]),
			_: 1
		})]),
		_: 1
	});
}
t(_sfc_render$9, "_sfc_render");
var gn = /* @__PURE__ */ r(hn, [["render", _sfc_render$9]]), _n = M({
	name: "RequestPasswordReset",
	emits: ["cancel", "success"],
	data() {
		return {
			email: "",
			emailError: !1,
			emailHint: "",
			isSubmitting: !1,
			requestSent: !1
		};
	},
	methods: {
		validateEmail() {
			this.emailError = !1, this.emailHint = "", this.email && (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email) || (this.emailError = !0, this.emailHint = "Please enter a valid email address"));
		},
		async handleSubmit() {
			if (this.validateEmail(), !(this.emailError || !this.email)) {
				this.isSubmitting = !0;
				try {
					let e = typeof window < "u" ? window.location.origin : void 0, t = await requestPasswordReset(this.email, e);
					t.ok ? (this.requestSent = !0, this.$emit("success", this.email)) : Z({
						text: t.error || "Failed to send reset email",
						status: J.error
					});
				} catch {
					Z({
						text: "An unexpected error occurred",
						status: J.error
					});
				} finally {
					this.isSubmitting = !1;
				}
			}
		}
	}
}), vn = {
	key: 1,
	class: "text-center"
};
function _sfc_render$8(e, t, n, r, i, a) {
	let o = V("v-card-title"), s = V("v-text-field"), c = V("v-icon"), l = V("v-btn"), u = V("v-form"), d = V("v-card-text"), f = V("v-spacer"), p = V("v-card-actions"), m = V("v-card");
	return L(), E(m, null, {
		default: W(() => [
			j(o, { class: "text-h5 bg-grey-lighten-2" }, {
				default: W(() => t[2] || (t[2] = [A(" Reset Password ")])),
				_: 1
			}),
			j(d, { class: "pa-6" }, {
				default: W(() => [e.requestSent ? (L(), O("div", vn, [
					j(c, {
						color: "success",
						size: "64",
						class: "mb-4"
					}, {
						default: W(() => t[6] || (t[6] = [A("mdi-email-check")])),
						_: 1
					}),
					t[9] || (t[9] = k("h3", { class: "mb-2" }, "Check Your Email", -1)),
					k("p", null, [
						t[7] || (t[7] = A(" If an account exists with ")),
						k("strong", null, H(e.email), 1),
						t[8] || (t[8] = A(", you will receive a password reset link shortly. "))
					]),
					t[10] || (t[10] = k("p", { class: "text-caption mt-4" }, "Didn't receive an email? Check your spam folder.", -1))
				])) : (L(), E(u, {
					key: 0,
					onSubmit: K(e.handleSubmit, ["prevent"])
				}, {
					default: W(() => [
						t[5] || (t[5] = k("p", { class: "mb-4" }, " Enter your email address and we'll send you a link to reset your password. ", -1)),
						j(s, {
							modelValue: e.email,
							"onUpdate:modelValue": t[0] || (t[0] = (t) => e.email = t),
							name: "email",
							label: "Email address",
							type: "email",
							"prepend-icon": "mdi-email",
							error: e.emailError,
							hint: e.emailHint,
							disabled: e.isSubmitting,
							onBlur: e.validateEmail
						}, null, 8, [
							"modelValue",
							"error",
							"hint",
							"disabled",
							"onBlur"
						]),
						j(l, {
							type: "submit",
							color: "primary",
							class: "mt-4",
							loading: e.isSubmitting,
							disabled: !e.email || e.emailError,
							block: ""
						}, {
							default: W(() => [j(c, { start: "" }, {
								default: W(() => t[3] || (t[3] = [A("mdi-email-send")])),
								_: 1
							}), t[4] || (t[4] = A(" Send Reset Link "))]),
							_: 1
						}, 8, ["loading", "disabled"])
					]),
					_: 1
				}, 8, ["onSubmit"]))]),
				_: 1
			}),
			e.requestSent ? D("", !0) : (L(), E(p, { key: 0 }, {
				default: W(() => [B(e.$slots, "back-action", {}, () => [j(l, {
					variant: "text",
					onClick: t[1] || (t[1] = (t) => e.$emit("cancel"))
				}, {
					default: W(() => t[11] || (t[11] = [A(" Cancel ")])),
					_: 1
				})]), j(f)]),
				_: 3
			}))
		]),
		_: 3
	});
}
t(_sfc_render$8, "_sfc_render");
var yn = /* @__PURE__ */ r(_n, [["render", _sfc_render$8]]), bn = { key: 0 }, xn = { key: "login-buttons" }, Sn = { key: "user-chip" }, Cn = /* @__PURE__ */ r(/* @__PURE__ */ M({
	__name: "UserLoginAndRegistrationContainer",
	props: {
		showLoginButton: { type: Boolean },
		redirectToPath: {},
		showRegistration: { type: Boolean },
		onSignupSuccess: { type: Function }
	},
	emits: ["signup-success"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Ce(), a = useAuthStore(), o = useAuthUI();
		I(async () => {
			await o.detectSyncStrategy();
		});
		let s = T(() => {
			if (!i.name || typeof i.name != "string") return !0;
			let e = i.name.toLowerCase();
			return !(e === "login" || e === "signup");
		}), c = T(() => a.onLoadComplete), l = T(() => a._user ? a._user.getUsername().startsWith(_e) : !a.loginAndRegistration.loggedIn), u = T(() => ({
			...o.config.value || {
				showLoginRegistration: !0,
				showLogout: !0,
				showResetData: !1,
				logoutLabel: "Log out",
				resetLabel: ""
			},
			...n.showRegistration !== void 0 && { showLoginRegistration: n.showRegistration }
		})), d = T({
			get: () => a.loginAndRegistration.regDialogOpen,
			set: (e) => {
				a.loginAndRegistration.regDialogOpen = e;
			}
		}), f = T({
			get: () => a.loginAndRegistration.loginDialogOpen,
			set: (e) => {
				a.loginAndRegistration.loginDialogOpen = e;
			}
		}), p = R(!1), toggle = () => {
			if (d.value && f.value) throw Error("Registration / Login dialogs both activated.");
			if (d.value === f.value) throw Error("Registration / Login dialogs toggled while both were dormant.");
			d.value = !d.value, f.value = !f.value;
		}, openResetDialog = () => {
			f.value = !1, p.value = !0;
		}, closeResetDialog = () => {
			p.value = !1;
		}, handleSignupSuccess = (e) => {
			d.value = !1, n.onSignupSuccess && n.onSignupSuccess(e), r("signup-success", e);
		};
		return (e, t) => {
			let n = V("v-btn"), r = V("v-dialog");
			return c.value && s.value ? (L(), O("div", bn, [j(w, {
				name: "component-fade",
				mode: "out-in"
			}, {
				default: W(() => [l.value ? (L(), O("div", xn, [
					u.value.showLoginRegistration ? (L(), E(r, {
						key: 0,
						modelValue: d.value,
						"onUpdate:modelValue": t[0] || (t[0] = (e) => d.value = e),
						width: "500px"
					}, {
						activator: W(({ props: e }) => [j(n, P({
							class: "mr-2",
							size: "small",
							color: "success"
						}, e), {
							default: W(() => t[3] || (t[3] = [A("Sign Up")])),
							_: 2
						}, 1040)]),
						default: W(() => [j(gn, {
							onToggle: toggle,
							onSignupSuccess: handleSignupSuccess,
							"on-signup-success": handleSignupSuccess
						})]),
						_: 1
					}, 8, ["modelValue"])) : D("", !0),
					j(r, {
						modelValue: f.value,
						"onUpdate:modelValue": t[1] || (t[1] = (e) => f.value = e),
						width: "500px"
					}, {
						activator: W(({ props: e }) => [j(n, P({
							size: "small",
							color: "success"
						}, e), {
							default: W(() => t[4] || (t[4] = [A("Log In")])),
							_: 2
						}, 1040)]),
						default: W(() => [j(mn, {
							onToggle: toggle,
							onForgotPassword: openResetDialog
						})]),
						_: 1
					}, 8, ["modelValue"]),
					j(r, {
						modelValue: p.value,
						"onUpdate:modelValue": t[2] || (t[2] = (e) => p.value = e),
						width: "500px"
					}, {
						default: W(() => [j(yn, {
							onCancel: closeResetDialog,
							onSuccess: closeResetDialog
						})]),
						_: 1
					}, 8, ["modelValue"])
				])) : (L(), O("div", Sn, [j(dn)]))]),
				_: 1
			})])) : D("", !0);
		};
	}
}), [["__scopeId", "data-v-5a55bdf0"]]), wn = M({
	name: "VerifyEmail",
	emits: ["verified", "error"],
	props: { token: {
		type: String,
		default: null
	} },
	data() {
		return {
			isVerifying: !1,
			verificationStatus: null,
			errorMessage: "",
			username: ""
		};
	},
	async mounted() {
		await this.performVerification();
	},
	methods: {
		async performVerification() {
			let e = this.token || this.getTokenFromURL();
			if (!e) {
				this.verificationStatus = "error", this.errorMessage = "No verification token provided";
				return;
			}
			this.isVerifying = !0;
			try {
				let t = await verifyEmail(e);
				t.ok ? (this.verificationStatus = "success", this.username = t.username || "", Z({
					text: "Email verified successfully!",
					status: J.ok
				})) : (this.verificationStatus = "error", this.errorMessage = t.error || "Verification failed", Z({
					text: t.error || "Verification failed",
					status: J.error
				}));
			} catch {
				this.verificationStatus = "error", this.errorMessage = "An unexpected error occurred", Z({
					text: "An unexpected error occurred",
					status: J.error
				});
			} finally {
				this.isVerifying = !1;
			}
		},
		getTokenFromURL() {
			return typeof window > "u" ? null : new URLSearchParams(window.location.search).get("token");
		}
	}
}), Tn = {
	key: 0,
	class: "text-center"
}, En = {
	key: 1,
	class: "text-center"
}, Dn = { key: 0 }, On = {
	key: 2,
	class: "text-center"
}, kn = {
	key: 3,
	class: "text-center"
};
function _sfc_render$7(e, t, n, r, i, a) {
	let o = V("v-card-title"), s = V("v-progress-circular"), c = V("v-icon"), l = V("v-card-text"), u = V("v-spacer"), d = V("v-btn"), f = V("v-card-actions"), p = V("v-card"), m = V("v-col"), h = V("v-row"), g = V("v-container");
	return L(), E(g, {
		class: "fill-height",
		fluid: ""
	}, {
		default: W(() => [j(h, {
			align: "center",
			justify: "center"
		}, {
			default: W(() => [j(m, {
				cols: "12",
				sm: "8",
				md: "6"
			}, {
				default: W(() => [j(p, null, {
					default: W(() => [
						j(o, { class: "text-h5 bg-grey-lighten-2" }, {
							default: W(() => t[2] || (t[2] = [A(" Email Verification ")])),
							_: 1
						}),
						j(l, { class: "pa-6" }, {
							default: W(() => [e.isVerifying ? (L(), O("div", Tn, [j(s, {
								indeterminate: "",
								color: "primary",
								size: "64",
								class: "mb-4"
							}), t[3] || (t[3] = k("p", null, "Verifying your email...", -1))])) : e.verificationStatus === "success" ? (L(), O("div", En, [
								j(c, {
									color: "success",
									size: "64",
									class: "mb-4"
								}, {
									default: W(() => t[4] || (t[4] = [A("mdi-check-circle")])),
									_: 1
								}),
								t[5] || (t[5] = k("h3", { class: "mb-2" }, "Email Verified!", -1)),
								t[6] || (t[6] = k("p", null, "Your account has been successfully verified.", -1)),
								e.username ? (L(), O("p", Dn, "Welcome, " + H(e.username) + "!", 1)) : D("", !0)
							])) : e.verificationStatus === "error" ? (L(), O("div", On, [
								j(c, {
									color: "error",
									size: "64",
									class: "mb-4"
								}, {
									default: W(() => t[7] || (t[7] = [A("mdi-alert-circle")])),
									_: 1
								}),
								t[8] || (t[8] = k("h3", { class: "mb-2" }, "Verification Failed", -1)),
								k("p", null, H(e.errorMessage), 1)
							])) : (L(), O("div", kn, [
								j(c, {
									color: "warning",
									size: "64",
									class: "mb-4"
								}, {
									default: W(() => t[9] || (t[9] = [A("mdi-help-circle")])),
									_: 1
								}),
								t[10] || (t[10] = k("h3", { class: "mb-2" }, "No Verification Token", -1)),
								t[11] || (t[11] = k("p", null, "Please use the link from your verification email.", -1))
							]))]),
							_: 1
						}),
						j(f, null, {
							default: W(() => [j(u), B(e.$slots, "actions", {
								status: e.verificationStatus,
								username: e.username
							}, () => [e.verificationStatus === "success" ? (L(), E(d, {
								key: 0,
								color: "primary",
								onClick: t[0] || (t[0] = (t) => e.$emit("verified", e.username))
							}, {
								default: W(() => t[12] || (t[12] = [A(" Continue ")])),
								_: 1
							})) : e.verificationStatus === "error" ? (L(), E(d, {
								key: 1,
								variant: "text",
								onClick: t[1] || (t[1] = (t) => e.$emit("error", e.errorMessage))
							}, {
								default: W(() => t[13] || (t[13] = [A(" Close ")])),
								_: 1
							})) : D("", !0)])]),
							_: 3
						})
					]),
					_: 3
				})]),
				_: 3
			})]),
			_: 3
		})]),
		_: 3
	});
}
t(_sfc_render$7, "_sfc_render");
var An = /* @__PURE__ */ r(wn, [["render", _sfc_render$7]]), jn = M({
	name: "ResetPassword",
	emits: ["complete", "error"],
	props: { token: {
		type: String,
		default: null
	} },
	data() {
		return {
			password: "",
			confirmPassword: "",
			passwordVisible: !1,
			confirmPasswordError: !1,
			confirmPasswordHint: "",
			isSubmitting: !1,
			isComplete: !1
		};
	},
	computed: { canSubmit() {
		return this.password.length >= 4 && this.confirmPassword.length >= 4 && this.password === this.confirmPassword && !this.confirmPasswordError;
	} },
	methods: {
		validateConfirmPassword() {
			this.confirmPasswordError = !1, this.confirmPasswordHint = "", this.confirmPassword && this.password !== this.confirmPassword && (this.confirmPasswordError = !0, this.confirmPasswordHint = "Passwords do not match");
		},
		async handleSubmit() {
			if (this.validateConfirmPassword(), !this.canSubmit) return;
			let e = this.token || this.getTokenFromURL();
			if (!e) {
				Z({
					text: "No reset token provided. Please use the link from your email.",
					status: J.error
				}), this.$emit("error", "No token");
				return;
			}
			this.isSubmitting = !0;
			try {
				let t = await resetPassword(e, this.password);
				t.ok ? (this.isComplete = !0, Z({
					text: "Password reset successfully!",
					status: J.ok
				})) : (Z({
					text: t.error || "Failed to reset password",
					status: J.error
				}), this.$emit("error", t.error));
			} catch {
				Z({
					text: "An unexpected error occurred",
					status: J.error
				}), this.$emit("error", "Unexpected error");
			} finally {
				this.isSubmitting = !1;
			}
		},
		getTokenFromURL() {
			return typeof window > "u" ? null : new URLSearchParams(window.location.search).get("token");
		}
	}
}), Mn = {
	key: 1,
	class: "text-center"
};
function _sfc_render$6(e, t, n, r, i, a) {
	let o = V("v-card-title"), s = V("v-text-field"), c = V("v-icon"), l = V("v-btn"), u = V("v-form"), d = V("v-card-text"), f = V("v-spacer"), p = V("v-card-actions"), m = V("v-card"), h = V("v-col"), g = V("v-row"), _ = V("v-container");
	return L(), E(_, {
		class: "fill-height",
		fluid: ""
	}, {
		default: W(() => [j(g, {
			align: "center",
			justify: "center"
		}, {
			default: W(() => [j(h, {
				cols: "12",
				sm: "8",
				md: "6"
			}, {
				default: W(() => [j(m, null, {
					default: W(() => [
						j(o, { class: "text-h5 bg-grey-lighten-2" }, {
							default: W(() => t[4] || (t[4] = [A(" Set New Password ")])),
							_: 1
						}),
						j(d, { class: "pa-6" }, {
							default: W(() => [e.isComplete ? (L(), O("div", Mn, [
								j(c, {
									color: "success",
									size: "64",
									class: "mb-4"
								}, {
									default: W(() => t[8] || (t[8] = [A("mdi-check-circle")])),
									_: 1
								}),
								t[9] || (t[9] = k("h3", { class: "mb-2" }, "Password Reset Successful!", -1)),
								t[10] || (t[10] = k("p", null, "Your password has been updated. You can now log in with your new password.", -1))
							])) : (L(), E(u, {
								key: 0,
								onSubmit: K(e.handleSubmit, ["prevent"])
							}, {
								default: W(() => [
									t[7] || (t[7] = k("p", { class: "mb-4" }, "Enter your new password below.", -1)),
									j(s, {
										modelValue: e.password,
										"onUpdate:modelValue": t[0] || (t[0] = (t) => e.password = t),
										"prepend-icon": "mdi-lock",
										name: "password",
										label: "New password",
										min: "4",
										"append-icon": e.passwordVisible ? "mdi-eye-off" : "mdi-eye",
										type: e.passwordVisible ? "text" : "password",
										disabled: e.isSubmitting,
										"onClick:append": t[1] || (t[1] = () => e.passwordVisible = !e.passwordVisible)
									}, null, 8, [
										"modelValue",
										"append-icon",
										"type",
										"disabled"
									]),
									j(s, {
										modelValue: e.confirmPassword,
										"onUpdate:modelValue": t[2] || (t[2] = (t) => e.confirmPassword = t),
										"prepend-icon": "mdi-lock",
										name: "confirmPassword",
										label: "Confirm new password",
										min: "4",
										type: e.passwordVisible ? "text" : "password",
										error: e.confirmPasswordError,
										hint: e.confirmPasswordHint,
										disabled: e.isSubmitting,
										onBlur: e.validateConfirmPassword
									}, null, 8, [
										"modelValue",
										"type",
										"error",
										"hint",
										"disabled",
										"onBlur"
									]),
									j(l, {
										type: "submit",
										color: "primary",
										class: "mt-4",
										loading: e.isSubmitting,
										disabled: !e.canSubmit,
										block: ""
									}, {
										default: W(() => [j(c, { start: "" }, {
											default: W(() => t[5] || (t[5] = [A("mdi-lock-reset")])),
											_: 1
										}), t[6] || (t[6] = A(" Reset Password "))]),
										_: 1
									}, 8, ["loading", "disabled"])
								]),
								_: 1
							}, 8, ["onSubmit"]))]),
							_: 1
						}),
						e.isComplete ? (L(), E(p, { key: 0 }, {
							default: W(() => [j(f), B(e.$slots, "success-action", {}, () => [j(l, {
								color: "primary",
								onClick: t[3] || (t[3] = (t) => e.$emit("complete"))
							}, {
								default: W(() => t[11] || (t[11] = [A(" Continue to Login ")])),
								_: 1
							})])]),
							_: 3
						})) : D("", !0)
					]),
					_: 3
				})]),
				_: 3
			})]),
			_: 3
		})]),
		_: 3
	});
}
t(_sfc_render$6, "_sfc_render");
var Nn = /* @__PURE__ */ r(jn, [["render", _sfc_render$6]]), Pn = M({
	name: "SkTagsInput",
	components: { VueTagsInput: Te },
	props: {
		courseID: {
			type: String,
			required: !0,
			default: ""
		},
		cardID: {
			type: String,
			required: !1,
			default: ""
		},
		hideSubmit: {
			type: Boolean,
			required: !1,
			default: !1
		}
	},
	data() {
		return {
			loading: !0,
			tag: "",
			tags: [],
			initialTags: [],
			availableCourseTags: [],
			separators: [
				";",
				",",
				" "
			],
			courseDB: null
		};
	},
	computed: { autoCompleteSuggestions() {
		return this.availableCourseTags.filter((e) => e.name.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1).map((e) => ({
			text: e.name,
			data: { snippet: e.snippet }
		}));
	} },
	watch: {
		async cardID() {
			await this.getAppliedTags();
		},
		async courseID() {
			this.courseDB = X().getCourseDB(this.courseID), await this.updateAvailableCourseTags();
		}
	},
	async created() {
		this.courseDB = X().getCourseDB(this.courseID), await this.updateAvailableCourseTags(), await this.getAppliedTags();
	},
	methods: {
		tagsChanged(e) {
			console.log(`[TagsInput] Tags changing: ${JSON.stringify(e)}`), this.tags = e;
		},
		async getAppliedTags() {
			this.initialTags = [], this.tags = [];
			try {
				(await this.courseDB.getAppliedTags(this.cardID)).rows.forEach((e) => {
					console.log(`[TagsInput] The following tag is applied:
\t${JSON.stringify(e)}`), this.tags.push({
						text: e.value.name,
						style: "",
						classes: ""
					});
				}), this.initialTags = this.tags.map((e) => e.text);
			} catch (e) {
				console.error(`Error in init-getAppliedTags: ${JSON.stringify(e)}, ${e}`);
			} finally {
				this.loading = !1;
			}
		},
		async updateAvailableCourseTags() {
			try {
				this.availableCourseTags = (await this.courseDB.getCourseTagStubs()).rows.map((e) => e.doc);
			} catch (e) {
				console.error(`Error in init-availableCourseTags: ${JSON.stringify(e)}`);
			}
		},
		async submit() {
			console.log("[TagsInput] tagsInput is submitting..."), this.loading = !0;
			try {
				await Promise.all(this.tags.map(async (e) => {
					if (!this.initialTags.includes(e.text)) try {
						await this.courseDB.addTagToCard(this.cardID, e.text), console.log(`[TagsInput] Successfully added tag: ${e.text}`);
					} catch (t) {
						console.error(`Failed to add tag ${e.text}:`, t);
					}
				}));
			} catch (e) {
				console.error(`Exception adding tags: ${JSON.stringify(e)}`);
			}
			try {
				await Promise.all(this.initialTags.map(async (e) => {
					if (this.tags.filter((t) => t.text === e).length === 0) try {
						await this.courseDB.removeTagFromCard(this.cardID, e), console.log(`[TagsInput] Successfully removed tag: ${e}`);
					} catch (t) {
						console.error(`Failed to remove tag ${e}:`, t);
					}
				}));
			} catch (e) {
				console.error(`Exception removing tags: ${JSON.stringify(e)}`);
			}
			this.loading = !1;
		}
	}
}), Fn = { "data-cy": "tags-input" }, In = { class: "tag-name" }, Ln = {
	key: 0,
	class: "tag-snippet"
};
function _sfc_render$5(e, t, n, r, i, a) {
	let o = V("vue-tags-input"), s = V("v-btn");
	return L(), O("div", Fn, [j(o, {
		modelValue: e.tag,
		"onUpdate:modelValue": t[0] || (t[0] = (t) => e.tag = t),
		tags: e.tags,
		"autocomplete-items": e.autoCompleteSuggestions,
		separators: e.separators,
		"add-on-key": e.separators,
		onTagsChanged: e.tagsChanged
	}, {
		"autocomplete-item": W((e) => [k("div", { class: F(["autocomplete-item", { "is-active": e.selected }]) }, [k("span", In, H(e.item.text), 1), e.item.data && e.item.data.snippet ? (L(), O("span", Ln, " - " + H(e.item.data.snippet), 1)) : D("", !0)], 2)]),
		_: 1
	}, 8, [
		"modelValue",
		"tags",
		"autocomplete-items",
		"separators",
		"add-on-key",
		"onTagsChanged"
	]), e.hideSubmit ? D("", !0) : (L(), E(s, {
		key: 0,
		color: "success",
		loading: e.loading,
		onClick: e.submit
	}, {
		default: W(() => t[1] || (t[1] = [A("Save Changes")])),
		_: 1
	}, 8, ["loading", "onClick"]))]);
}
t(_sfc_render$5, "_sfc_render");
var Rn = /* @__PURE__ */ r(Pn, [["render", _sfc_render$5], ["__scopeId", "data-v-f7373dc0"]]), zn = M({
	name: "CourseCardBrowser",
	components: {
		CardLoader: un,
		TagsInput: Rn,
		PaginatingToolbar: Ue
	},
	props: {
		courseId: {
			type: String,
			required: !0
		},
		tagId: {
			type: String,
			required: !1,
			default: ""
		},
		viewLookupFunction: {
			type: Function,
			required: !0,
			default: () => (console.warn("No viewLookupFunction provided to CourseCardBrowser"), null)
		},
		editMode: {
			type: String,
			required: !1,
			default: "full"
		}
	},
	data() {
		return {
			courseDB: null,
			page: 1,
			pages: [],
			cards: [],
			cardData: {},
			cardPreview: {},
			cardElos: {},
			cardTags: {},
			internalEditMode: "none",
			delBtn: !1,
			updatePending: !0,
			userIsRegistered: !1,
			questionCount: 0,
			tags: [],
			viewLookup: this.viewLookupFunction
		};
	},
	async created() {
		try {
			this.courseDB = X().getCourseDB(this.courseId), this.tagId ? this.questionCount = (await this.courseDB.getTag(this.tagId)).taggedCards.length : this.questionCount = (await this.courseDB.getCourseInfo()).cardCount;
			for (let e = 1; (e - 1) * 25 < this.questionCount; e++) this.pages.push(e);
			await this.populateTableData();
		} catch (e) {
			console.error("Error initializing CourseCardBrowser:", e);
		} finally {
			this.updatePending = !1;
		}
	},
	methods: {
		idQualify(e) {
			return e.includes("-") ? e : `${this.courseId}-${e}`;
		},
		idToQualifiedObject(e) {
			if (e.includes("-")) {
				let t = e.split("-");
				return {
					courseID: t[0],
					cardID: t[1]
				};
			} else return {
				courseID: this.courseId,
				cardID: e
			};
		},
		first() {
			this.page = 1, this.populateTableData();
		},
		prev() {
			this.page--, this.populateTableData();
		},
		next() {
			this.page++, this.populateTableData();
		},
		last() {
			this.page = this.pages.length, this.populateTableData();
		},
		setPage(e) {
			this.page = e, this.populateTableData();
		},
		async loadCardTags(e) {
			try {
				await Promise.all(e.map(async (e) => {
					let t = await this.courseDB.getAppliedTags(e);
					this.cardTags[e] = t.rows.map((e) => ({
						name: e.value.name,
						snippet: e.value.snippet,
						count: e.value.count
					}));
				}));
			} catch (e) {
				console.error("Error loading card tags:", e);
			}
		},
		clearSelections(e = "") {
			this.cards.forEach((t) => {
				t.card.cardID !== e && (t.isOpen = !1);
			}), this.internalEditMode = "none", this.delBtn = !1;
		},
		async deleteCard(e) {
			console.log(`Deleting card ${e}`);
			let t = await this.courseDB.removeCard(e);
			t.ok ? (this.cards = this.cards.filter((t) => t.card.cardID != e), this.clearSelections()) : (console.error(`Failed to delete card:\n\n${JSON.stringify(t)}`), Z({
				text: "Failed to delete card",
				status: J.error
			}));
		},
		async populateTableData() {
			this.updatePending = !0, this.tagId ? this.cards = (await this.courseDB.getTag(this.tagId)).taggedCards.map((e) => ({
				card: {
					cardID: e,
					courseID: this.courseId
				},
				isOpen: !1,
				delBtn: !1
			})) : this.cards = (await this.courseDB.getCardsByELO(0, 25)).map((e) => ({
				card: e,
				isOpen: !1,
				delBtn: !1
			}));
			let e = [], t = (await this.courseDB.getCourseDocs(this.cards.map((e) => e.card.cardID), { include_docs: !0 })).rows.filter((e) => e.doc ? !0 : (console.error(`Card ${e.id}.doc not found.\ncard: ${JSON.stringify(e)}`), !1)).map((e) => e.doc);
			this.cards = this.cards.filter((t) => !e.includes(t.card.cardID)), t.forEach((e) => {
				e && e.id_displayable_data && (this.cardData[e._id] = e.id_displayable_data);
			});
			try {
				await Promise.all(this.cards.map(async (e) => {
					let n = e.card.cardID, r = t.find((e) => e._id == n);
					if (!r || !r.id_displayable_data) {
						console.error(`No valid data found for card ${n}`);
						return;
					}
					let i = this.viewLookupFunction(r.id_view || "default.question.BlanksCard.FillInView"), a = r.id_displayable_data.map((e) => this.courseDB.getCourseDoc(e, {
						attachments: !1,
						binary: !0
					})), o = await Promise.all(a);
					await Promise.all(o.map((t) => {
						[].unshift(pe(t)), this.cardPreview[e.card.cardID] = i.name ? i.name : "Unknown";
					}));
				}));
				let e = this.cards.map((e) => e.card.cardID), n = await this.courseDB.getCardEloData(e);
				e.forEach((e, t) => {
					this.cardElos[e] = n[t];
				}), await this.loadCardTags(e);
			} catch (e) {
				console.error("Error populating table data:", e);
			} finally {
				this.updatePending = !1, this.$forceUpdate();
			}
		}
	}
}), Bn = {
	key: 0,
	class: "d-flex justify-center align-center pa-6"
}, Vn = { key: 1 }, Hn = {
	key: 0,
	class: "px-4 py-2 bg-blue-grey-lighten-5"
}, Un = {
	key: 0,
	class: "mt-4"
}, Wn = { class: "mt-4" }, Gn = {
	key: 0,
	class: "ml-4"
};
function _sfc_render$4(e, t, n, r, i, a) {
	let o = V("v-progress-circular"), s = V("paginating-toolbar"), c = V("v-list-item-title"), l = V("v-list-item-subtitle"), u = V("v-btn"), d = V("v-icon"), f = V("v-speed-dial"), p = V("v-list-item"), m = V("card-loader"), h = V("v-chip"), g = V("v-chip-group"), _ = V("tags-input"), v = V("v-list"), y = V("v-card");
	return L(), E(y, null, {
		default: W(() => [e.updatePending ? (L(), O("div", Bn, [j(o, {
			indeterminate: "",
			color: "primary"
		})])) : (L(), O("div", Vn, [
			j(s, {
				title: "Exercises",
				page: e.page,
				pages: e.pages,
				subtitle: `(${e.questionCount})`,
				onFirst: e.first,
				onPrev: e.prev,
				onNext: e.next,
				onLast: e.last,
				onSetPage: t[0] || (t[0] = (t) => e.setPage(t))
			}, null, 8, [
				"page",
				"pages",
				"subtitle",
				"onFirst",
				"onPrev",
				"onNext",
				"onLast"
			]),
			j(v, null, {
				default: W(() => [(L(!0), O(C, null, z(e.cards, (n) => (L(), O(C, { key: n.card.cardID }, [j(p, {
					class: F({
						"bg-blue-grey-lighten-5": n.isOpen,
						"elevation-4": n.isOpen
					}),
					density: "compact",
					"data-cy": "course-card"
				}, {
					prepend: W(() => [k("div", null, [j(c, { class: F([{ "text-blue-grey-darken-1": n.isOpen }, "font-weight-medium"]) }, {
						default: W(() => [A(H(e.cardPreview[n.card.cardID]), 1)]),
						_: 2
					}, 1032, ["class"]), j(l, null, {
						default: W(() => [A(" ELO: " + H(e.cardElos[n.card.cardID]?.global?.score || "(unknown)"), 1)]),
						_: 2
					}, 1024)])]),
					append: W(() => [j(f, {
						modelValue: n.isOpen,
						"onUpdate:modelValue": (e) => n.isOpen = e,
						location: "left center",
						transition: "slide-x-transition",
						style: {
							display: "flex",
							"flex-direction": "row-reverse"
						},
						persistent: ""
					}, {
						activator: W(({ props: t }) => [j(u, P({ ref_for: !0 }, t, {
							icon: n.isOpen ? "mdi-close" : "mdi-plus",
							size: "small",
							variant: "text",
							onClick: (t) => e.clearSelections(n.card.cardID)
						}), null, 16, ["icon", "onClick"])]),
						default: W(() => [e.editMode === "full" ? (L(), E(u, {
							key: "tags",
							icon: "",
							size: "small",
							variant: e.internalEditMode === "tags" ? "elevated" : "outlined",
							color: e.internalEditMode === "tags" ? "teal" : "teal-darken-3",
							onClick: t[1] || (t[1] = K((t) => e.internalEditMode = "tags", ["stop"]))
						}, {
							default: W(() => [j(d, null, {
								default: W(() => t[4] || (t[4] = [A("mdi-bookmark")])),
								_: 1
							})]),
							_: 1
						}, 8, ["variant", "color"])) : D("", !0), e.editMode === "full" ? (L(), E(u, {
							key: "flag",
							icon: "",
							size: "small",
							variant: e.internalEditMode === "flag" ? "elevated" : "outlined",
							color: e.internalEditMode === "flag" ? "error" : "error-darken-3",
							onClick: t[2] || (t[2] = K((t) => e.internalEditMode = "flag", ["stop"]))
						}, {
							default: W(() => [j(d, null, {
								default: W(() => t[5] || (t[5] = [A("mdi-flag")])),
								_: 1
							})]),
							_: 1
						}, 8, ["variant", "color"])) : D("", !0)]),
						_: 2
					}, 1032, ["modelValue", "onUpdate:modelValue"])]),
					_: 2
				}, 1032, ["class"]), n.isOpen ? (L(), O("div", Hn, [
					j(m, {
						qualified_id: n.card,
						"view-lookup": e.viewLookup,
						class: "elevation-1"
					}, null, 8, ["qualified_id", "view-lookup"]),
					e.editMode === "readonly" && e.cardTags[n.card.cardID] ? (L(), O("div", Un, [j(g, null, {
						default: W(() => [(L(!0), O(C, null, z(e.cardTags[n.card.cardID], (e) => (L(), E(h, {
							key: e.name,
							size: "small",
							color: "primary",
							variant: "outlined"
						}, {
							default: W(() => [A(H(e.name), 1)]),
							_: 2
						}, 1024))), 128))]),
						_: 2
					}, 1024)])) : D("", !0),
					de(j(_, {
						"course-i-d": e.courseId,
						"card-i-d": n.card.cardID,
						class: "mt-4"
					}, null, 8, ["course-i-d", "card-i-d"]), [[ue, e.internalEditMode === "tags" && e.editMode === "full"]]),
					de(k("div", Wn, [j(u, {
						color: "error",
						variant: "outlined",
						onClick: (e) => n.delBtn = !0
					}, {
						default: W(() => t[6] || (t[6] = [A(" Delete this card ")])),
						_: 2
					}, 1032, ["onClick"]), n.delBtn ? (L(), O("span", Gn, [t[8] || (t[8] = k("span", { class: "mr-2" }, "Are you sure?", -1)), j(u, {
						color: "error",
						variant: "elevated",
						onClick: (t) => e.deleteCard(n.card.cardID)
					}, {
						default: W(() => t[7] || (t[7] = [A(" Confirm ")])),
						_: 2
					}, 1032, ["onClick"])])) : D("", !0)], 512), [[ue, e.internalEditMode === "flag" && e.editMode === "full"]])
				])) : D("", !0)], 64))), 128))]),
				_: 1
			}),
			j(s, {
				class: "elevation-0",
				page: e.page,
				pages: e.pages,
				onFirst: e.first,
				onPrev: e.prev,
				onNext: e.next,
				onLast: e.last,
				onSetPage: t[3] || (t[3] = (t) => e.setPage(t))
			}, null, 8, [
				"page",
				"pages",
				"onFirst",
				"onPrev",
				"onNext",
				"onLast"
			])
		]))]),
		_: 1
	});
}
t(_sfc_render$4, "_sfc_render");
var Kn = /* @__PURE__ */ r(zn, [["render", _sfc_render$4], ["__scopeId", "data-v-5ecc9d21"]]), qn = M({
	name: "CourseInformation",
	components: { CourseCardBrowser: Kn },
	props: {
		courseId: {
			type: String,
			required: !0
		},
		viewLookupFunction: {
			type: Function,
			required: !1,
			default: (e) => (console.warn("No viewLookupFunction provided to CourseInformation"), null)
		},
		editMode: {
			type: String,
			required: !1,
			default: "full"
		}
	},
	data() {
		return {
			courseDB: null,
			nameRules: [(e) => e.length > 30 ? "Course name must be 30 characters or less" : !0],
			updatePending: !0,
			courseConfig: {},
			userIsRegistered: !1,
			tags: [],
			user: null
		};
	},
	computed: {},
	async created() {
		this.courseDB = X().getCourseDB(this.courseId), this.user = await getCurrentUser();
		let e = await this.user.getCourseRegistrationsDoc();
		this.user.getUsername() === "admin" ? this.userIsRegistered = !0 : this.userIsRegistered = e.courses.filter((e) => e.courseID === this.courseId && (e.status === "active" || e.status === void 0)).length === 1, this.courseConfig = await this.courseDB.getCourseConfig(), this.tags = (await this.courseDB.getCourseTagStubs()).rows.map((e) => e.doc), this.updatePending = !1;
	},
	methods: {
		async register() {
			Y(`Registering for ${this.courseId}`), (await this.user.registerForCourse(this.courseId)).ok && (this.userIsRegistered = !0);
		},
		async drop() {
			Y(`Dropping course ${this.courseId}`), (await this.user.dropCourse(this.courseId)).ok && (this.userIsRegistered = !1);
		}
	}
}), Jn = { key: 0 }, Yn = { class: "text-h4 mb-2" }, Xn = { class: "text-body-2" }, Zn = { key: 0 }, Qn = { key: 1 };
function _sfc_render$3(e, t, n, r, i, a) {
	let o = V("v-btn"), s = V("v-icon"), c = V("v-toolbar-title"), l = V("v-toolbar-items"), u = V("v-toolbar"), d = V("v-chip"), f = V("v-card-text"), p = V("v-card"), m = V("course-card-browser");
	return e.updatePending ? D("", !0) : (L(), O("div", Jn, [
		B(e.$slots, "header", {
			courseConfig: e.courseConfig,
			courseId: e.courseId
		}, () => [k("h1", Yn, H(e.courseConfig.name), 1)], !0),
		k("p", Xn, H(e.courseConfig.description), 1),
		B(e.$slots, "actions", {
			userIsRegistered: e.userIsRegistered,
			courseId: e.courseId,
			editMode: e.editMode,
			register: e.register,
			drop: e.drop
		}, () => [j(w, {
			name: "component-fade",
			mode: "out-in"
		}, {
			default: W(() => [e.userIsRegistered ? (L(), O("div", Zn, [
				j(o, {
					color: "success",
					"data-cy": "focused-study-session-btn",
					class: "me-2"
				}, {
					default: W(() => t[0] || (t[0] = [A("Start ad study session")])),
					_: 1
				}),
				e.editMode === "full" ? (L(), E(o, {
					key: 0,
					"data-cy": "add-content-btn",
					color: "indigo-lighten-1",
					class: "me-2"
				}, {
					default: W(() => [j(s, { start: "" }, {
						default: W(() => t[1] || (t[1] = [A("mdi-plus")])),
						_: 1
					}), t[2] || (t[2] = A(" Add content "))]),
					_: 1
				})) : D("", !0),
				e.editMode === "full" ? (L(), E(o, {
					key: 1,
					color: "green-darken-2",
					title: "Rank course content for difficulty",
					class: "me-2"
				}, {
					default: W(() => [j(s, { start: "" }, {
						default: W(() => t[3] || (t[3] = [A("mdi-format-list-numbered")])),
						_: 1
					}), t[4] || (t[4] = A(" Arrange "))]),
					_: 1
				})) : D("", !0),
				e.editMode === "full" ? (L(), E(o, {
					key: 2,
					color: "error",
					size: "small",
					variant: "outlined",
					onClick: e.drop
				}, {
					default: W(() => t[5] || (t[5] = [A(" Drop this course ")])),
					_: 1
				}, 8, ["onClick"])) : D("", !0)
			])) : (L(), O("div", Qn, [j(o, {
				"data-cy": "register-btn",
				color: "primary",
				class: "me-2",
				onClick: e.register
			}, {
				default: W(() => t[6] || (t[6] = [A("Register")])),
				_: 1
			}, 8, ["onClick"]), j(o, {
				variant: "outlined",
				color: "primary",
				class: "me-2"
			}, {
				default: W(() => t[7] || (t[7] = [A("Start a trial study session")])),
				_: 1
			})]))]),
			_: 1
		})], !0),
		B(e.$slots, "additional-content", {}, void 0, !0),
		j(p, { class: "my-2" }, {
			default: W(() => [j(u, { density: "compact" }, {
				default: W(() => [j(c, null, {
					default: W(() => t[8] || (t[8] = [A("Tags")])),
					_: 1
				}), j(l, null, {
					default: W(() => [j(o, { variant: "text" }, {
						default: W(() => [A("(" + H(e.tags.length) + ")", 1)]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			}), j(f, null, {
				default: W(() => [(L(!0), O(C, null, z(e.tags, (t, n) => (L(), O("span", { key: n }, [B(e.$slots, "tag-link", {
					tag: t,
					courseId: e.courseId
				}, () => [j(d, {
					variant: "tonal",
					class: "me-2 mb-2"
				}, {
					default: W(() => [A(H(t.name), 1)]),
					_: 2
				}, 1024)], !0)]))), 128))]),
				_: 3
			})]),
			_: 3
		}),
		j(m, {
			class: "my-3",
			"course-id": e.courseId,
			"view-lookup-function": e.viewLookupFunction,
			"edit-mode": e.editMode
		}, null, 8, [
			"course-id",
			"view-lookup-function",
			"edit-mode"
		])
	]));
}
t(_sfc_render$3, "_sfc_render");
var $n = /* @__PURE__ */ r(qn, [["render", _sfc_render$3], ["__scopeId", "data-v-38e9efe1"]]), er = M({
	name: "CardBrowser",
	components: { CardViewer: Q },
	props: {
		views: {
			type: Array,
			required: !0
		},
		data: {
			type: Array,
			required: !0
		},
		suppressSpinner: {
			type: Boolean,
			default: !1
		}
	},
	data() {
		return {
			viewIndex: 0,
			previewMode: i()
		};
	},
	computed: { spinner() {
		return this.views.length > 1;
	} },
	created() {
		console.log("[CardBrowser] Card browser created. Cards now in 'prewviewMode'"), this.previewMode.setPreviewMode(!0);
	},
	unmounted() {
		console.log("[CardBrowser] Card browser unmounted. Cards no longer in 'prewviewMode'"), this.previewMode.setPreviewMode(!1);
	},
	methods: {
		incrementView() {
			this.viewIndex++, this.viewIndex = (this.viewIndex + this.views.length) % this.views.length;
		},
		decrementView() {
			this.viewIndex--, this.viewIndex = (this.viewIndex + this.views.length) % this.views.length;
		}
	}
}), tr = {
	key: 0,
	class: "text-subtitle-1 pa-2"
};
function _sfc_render$2(e, t, n, r, i, a) {
	let o = V("CardViewer"), s = V("v-icon"), c = V("v-btn"), l = V("v-row");
	return L(), E(l, {
		column: "",
		align: "center",
		justify: "center"
	}, {
		default: W(() => [
			j(o, {
				view: e.views[e.viewIndex],
				data: e.data,
				course_id: "[browsing]",
				card_id: "[browsing]"
			}, null, 8, ["view", "data"]),
			t[2] || (t[2] = k("br", null, null, -1)),
			t[3] || (t[3] = k("br", null, null, -1)),
			e.suppressSpinner ? D("", !0) : (L(), O("div", tr, [
				e.spinner ? (L(), E(c, {
					key: 0,
					icon: "",
					variant: "outlined",
					color: "primary",
					onClick: e.decrementView
				}, {
					default: W(() => [j(s, null, {
						default: W(() => t[0] || (t[0] = [A("mdi-chevron-left")])),
						_: 1
					})]),
					_: 1
				}, 8, ["onClick"])) : D("", !0),
				A(" " + H(e.views[e.viewIndex].name) + " ", 1),
				e.spinner ? (L(), E(c, {
					key: 1,
					icon: "",
					variant: "outlined",
					color: "primary",
					onClick: e.incrementView
				}, {
					default: W(() => [j(s, null, {
						default: W(() => t[1] || (t[1] = [A("mdi-chevron-right")])),
						_: 1
					})]),
					_: 1
				}, 8, ["onClick"])) : D("", !0)
			]))
		]),
		_: 1
	});
}
t(_sfc_render$2, "_sfc_render");
var nr = /* @__PURE__ */ r(er, [["render", _sfc_render$2]]), rr = M({
	name: "CourseTagFilterWidget",
	props: {
		courseId: {
			type: String,
			required: !0
		},
		modelValue: {
			type: Object,
			default: void 0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = R(!0), r = R([]), i = R({}), a = R(e.modelValue ? { ...e.modelValue } : me()), o = T(() => r.value.filter((e) => !a.value.include.includes(e))), s = T(() => he(a.value)), fuzzyFilter = (e, t) => {
			if (!t) return !0;
			let n = t.toLowerCase(), r = e.toLowerCase(), i = 0;
			for (let e = 0; e < r.length && i < n.length; e++) r[e] === n[i] && i++;
			return i === n.length;
		};
		U(() => e.modelValue, (e) => {
			e ? a.value = { ...e } : a.value = me();
		}, { deep: !0 }), U(a, (e) => {
			t("update:modelValue", { ...e });
		}, { deep: !0 }), U(() => e.courseId, async (e) => {
			e && await loadTags();
		});
		async function loadTags() {
			n.value = !0;
			try {
				let t = await X().getCourseDB(e.courseId).getCourseTagStubs();
				r.value = [], i.value = {};
				for (let e of t.rows) if (e.doc) {
					let t = e.doc;
					r.value.push(t.name), t.snippet && (i.value[t.name] = t.snippet);
				}
				r.value.sort((e, t) => e.localeCompare(t));
			} catch (e) {
				console.error("[CourseTagFilterWidget] Failed to load tags:", e), r.value = [], i.value = {};
			} finally {
				n.value = !1;
			}
		}
		return I(() => {
			e.courseId && loadTags();
		}), {
			loading: n,
			availableTags: r,
			availableTagsForExclude: o,
			tagSnippets: i,
			localFilter: a,
			hasActiveFilter: s,
			fuzzyFilter
		};
	}
}), ir = { class: "course-tag-filter-widget" }, ar = {
	key: 0,
	class: "filter-summary text-caption mt-2"
}, or = { key: 0 }, sr = { key: 1 }, cr = { key: 2 };
function _sfc_render$1(e, t, n, r, i, a) {
	let o = V("v-chip"), s = V("v-list-item"), c = V("v-autocomplete"), l = V("v-icon");
	return L(), O("div", ir, [
		j(c, {
			modelValue: e.localFilter.include,
			"onUpdate:modelValue": t[0] || (t[0] = (t) => e.localFilter.include = t),
			items: e.availableTags,
			loading: e.loading,
			disabled: e.loading,
			label: "Include tags",
			placeholder: "Type to search tags...",
			hint: "Cards must have at least one of these tags",
			"persistent-hint": "",
			multiple: "",
			chips: "",
			"closable-chips": "",
			clearable: "",
			density: "compact",
			variant: "outlined",
			class: "mb-2",
			"custom-filter": e.fuzzyFilter,
			"no-data-text": "No matching tags found"
		}, {
			chip: W(({ props: e, item: t }) => [j(o, P(e, {
				color: "primary",
				variant: "tonal",
				size: "small"
			}), {
				default: W(() => [A(H(t.raw), 1)]),
				_: 2
			}, 1040)]),
			item: W(({ props: t, item: n }) => [j(s, P(t, { title: n.raw }), ne({ _: 2 }, [e.tagSnippets[n.raw] ? {
				name: "subtitle",
				fn: W(() => [A(H(e.tagSnippets[n.raw]), 1)]),
				key: "0"
			} : void 0]), 1040, ["title"])]),
			_: 1
		}, 8, [
			"modelValue",
			"items",
			"loading",
			"disabled",
			"custom-filter"
		]),
		j(c, {
			modelValue: e.localFilter.exclude,
			"onUpdate:modelValue": t[1] || (t[1] = (t) => e.localFilter.exclude = t),
			items: e.availableTagsForExclude,
			loading: e.loading,
			disabled: e.loading,
			label: "Exclude tags",
			placeholder: "Type to search tags...",
			hint: "Cards with these tags will be excluded",
			"persistent-hint": "",
			multiple: "",
			chips: "",
			"closable-chips": "",
			clearable: "",
			density: "compact",
			variant: "outlined",
			"custom-filter": e.fuzzyFilter,
			"no-data-text": "No matching tags found"
		}, {
			chip: W(({ props: e, item: t }) => [j(o, P(e, {
				color: "error",
				variant: "tonal",
				size: "small"
			}), {
				default: W(() => [A(H(t.raw), 1)]),
				_: 2
			}, 1040)]),
			item: W(({ props: t, item: n }) => [j(s, P(t, { title: n.raw }), ne({ _: 2 }, [e.tagSnippets[n.raw] ? {
				name: "subtitle",
				fn: W(() => [A(H(e.tagSnippets[n.raw]), 1)]),
				key: "0"
			} : void 0]), 1040, ["title"])]),
			_: 1
		}, 8, [
			"modelValue",
			"items",
			"loading",
			"disabled",
			"custom-filter"
		]),
		e.hasActiveFilter ? (L(), O("div", ar, [
			j(l, {
				size: "small",
				color: "info",
				class: "mr-1"
			}, {
				default: W(() => t[2] || (t[2] = [A("mdi-filter")])),
				_: 1
			}),
			e.localFilter.include.length ? (L(), O("span", or, " Including: " + H(e.localFilter.include.join(", ")), 1)) : D("", !0),
			e.localFilter.include.length && e.localFilter.exclude.length ? (L(), O("span", sr, " · ")) : D("", !0),
			e.localFilter.exclude.length ? (L(), O("span", cr, " Excluding: " + H(e.localFilter.exclude.join(", ")), 1)) : D("", !0)
		])) : D("", !0)
	]);
}
t(_sfc_render$1, "_sfc_render");
var lr = /* @__PURE__ */ r(rr, [["render", _sfc_render$1], ["__scopeId", "data-v-e1ba963b"]]), $ = {
	min: 0,
	startingMax: 2,
	absoluteMax: 10
}, ur = "UserTagPreferenceFilter", dr = M({
	name: "UserTagPreferences",
	props: {
		courseId: {
			type: String,
			required: !1,
			default: ""
		},
		sliderConfig: {
			type: Object,
			required: !1,
			default: () => ({})
		}
	},
	emits: ["preferences-saved", "preferences-changed"],
	data() {
		return {
			loading: !0,
			saving: !1,
			saveError: "",
			saveSuccess: !1,
			preferences: { boost: {} },
			savedPreferences: { boost: {} },
			tagMaxRanges: {},
			availableTags: [],
			tagToAdd: null,
			courseDB: null,
			user: null
		};
	},
	computed: {
		sliderConfigResolved() {
			return {
				min: this.sliderConfig.min ?? $.min,
				startingMax: this.sliderConfig.startingMax ?? $.startingMax,
				absoluteMax: this.sliderConfig.absoluteMax ?? $.absoluteMax
			};
		},
		tagNames() {
			return Object.keys(this.preferences.boost).sort();
		},
		globalSliderMax() {
			let e = Object.values(this.tagMaxRanges);
			return e.length === 0 ? this.sliderConfigResolved.startingMax : Math.max(...e);
		},
		availableTagsToAdd() {
			let e = new Set(Object.keys(this.preferences.boost));
			return this.availableTags.filter((t) => !e.has(t.name));
		},
		hasChanges() {
			let e = Object.keys(this.preferences.boost).sort(), t = Object.keys(this.savedPreferences.boost).sort();
			return e.length !== t.length || e.join(",") !== t.join(",") ? !0 : e.some((e) => this.preferences.boost[e] !== this.savedPreferences.boost[e]);
		}
	},
	watch: { courseId: {
		immediate: !0,
		async handler(e) {
			e ? await this.loadPreferences() : this.loading = !1;
		}
	} },
	methods: {
		async loadPreferences() {
			this.loading = !0, this.saveError = "";
			try {
				if (this.user = await getCurrentUser() ?? null, !this.user) throw Error("User not available");
				this.courseDB = X().getCourseDB(this.courseId), this.availableTags = (await this.courseDB.getCourseTagStubs()).rows.map((e) => e.doc).filter(Boolean);
				let e = await this.user.getStrategyState(this.courseId, ur);
				e ? this.preferences.boost = { ...e.boost } : this.preferences.boost = {}, this.savedPreferences.boost = { ...this.preferences.boost }, this.tagMaxRanges = {}, Object.keys(this.preferences.boost).forEach((e) => {
					let t = this.preferences.boost[e], n = this.sliderConfigResolved.startingMax;
					t > n ? this.tagMaxRanges[e] = Math.min(Math.ceil(t), this.sliderConfigResolved.absoluteMax) : this.tagMaxRanges[e] = n;
				});
			} catch (e) {
				console.error("Failed to load preferences:", e), this.saveError = "Failed to load preferences. Please try again.";
			} finally {
				this.loading = !1;
			}
		},
		addTag(e) {
			e && !(e in this.preferences.boost) && (this.preferences.boost[e] = 1, this.tagMaxRanges[e] = this.sliderConfigResolved.startingMax, this.$emit("preferences-changed", this.preferences)), this.$nextTick(() => {
				this.tagToAdd = null;
			});
		},
		removeTag(e) {
			delete this.preferences.boost[e], delete this.tagMaxRanges[e], this.$emit("preferences-changed", this.preferences);
		},
		updateBoost(e, t) {
			this.preferences.boost[e] = t, this.$emit("preferences-changed", this.preferences);
		},
		expandSliderRange(e) {
			let t = this.globalSliderMax;
			if (t < this.sliderConfigResolved.absoluteMax) {
				let n = t + 1;
				Object.keys(this.tagMaxRanges).forEach((e) => {
					this.tagMaxRanges[e] = Math.max(this.tagMaxRanges[e], n);
				}), this.preferences.boost[e] = n, this.$emit("preferences-changed", this.preferences);
			}
		},
		formatMultiplier(e) {
			return e === 0 ? "0x" : e < .1 ? e.toFixed(2) + "x" : e.toFixed(1) + "x";
		},
		resetToSaved() {
			this.preferences.boost = { ...this.savedPreferences.boost }, this.saveSuccess = !1, this.saveError = "", this.tagMaxRanges = {}, Object.keys(this.preferences.boost).forEach((e) => {
				let t = this.preferences.boost[e], n = this.sliderConfigResolved.startingMax;
				t > n ? this.tagMaxRanges[e] = Math.min(Math.ceil(t), this.sliderConfigResolved.absoluteMax) : this.tagMaxRanges[e] = n;
			});
		},
		async savePreferences() {
			if (!this.user || !this.courseId) {
				this.saveError = "Unable to save - user or course not available";
				return;
			}
			this.saving = !0, this.saveError = "", this.saveSuccess = !1;
			try {
				let e = {
					boost: { ...this.preferences.boost },
					updatedAt: (/* @__PURE__ */ new Date()).toISOString()
				};
				await this.user.putStrategyState(this.courseId, ur, e), this.savedPreferences.boost = { ...this.preferences.boost }, this.saveSuccess = !0, this.$emit("preferences-saved", e);
			} catch (e) {
				console.error("Failed to save preferences:", e), this.saveError = "Failed to save preferences. Please try again.";
			} finally {
				this.saving = !1;
			}
		}
	}
}), fr = { key: 1 }, pr = { class: "mb-6" }, mr = { class: "text-subtitle-1 font-weight-bold mb-2" }, hr = { class: "d-flex align-center ga-3 w-100" }, gr = {
	class: "text-body-2 flex-shrink-0",
	style: {
		"min-width": "60px",
		"text-align": "right"
	}
}, _r = {
	key: 2,
	class: "d-flex justify-center py-8"
};
function _sfc_render(e, t, n, r, i, a) {
	let o = V("v-icon"), s = V("v-card-title"), c = V("v-card-subtitle"), l = V("v-alert"), u = V("v-list-item"), d = V("v-autocomplete"), f = V("v-chip"), p = V("v-slider"), m = V("v-btn"), h = V("v-list"), g = V("v-progress-circular"), _ = V("v-card-text"), v = V("v-spacer"), y = V("v-card-actions"), b = V("v-card");
	return L(), E(b, { loading: e.loading }, {
		default: W(() => [
			j(s, null, {
				default: W(() => [j(o, { start: "" }, {
					default: W(() => t[3] || (t[3] = [A("mdi-tune")])),
					_: 1
				}), t[4] || (t[4] = A(" Learning Preferences "))]),
				_: 1
			}),
			e.courseId ? (L(), E(c, { key: 0 }, {
				default: W(() => t[5] || (t[5] = [A(" Customize how content is presented in this course ")])),
				_: 1
			})) : D("", !0),
			j(_, null, {
				default: W(() => [e.courseId ? e.loading ? (L(), O("div", _r, [j(g, {
					indeterminate: "",
					color: "primary"
				})])) : (L(), O("div", fr, [
					k("div", pr, [
						k("h3", mr, [j(o, {
							start: "",
							size: "small"
						}, {
							default: W(() => t[7] || (t[7] = [A("mdi-tune-variant")])),
							_: 1
						}), t[8] || (t[8] = A(" Tag Preferences "))]),
						t[10] || (t[10] = k("p", { class: "text-body-2 text-medium-emphasis mb-3" }, " Adjust how much you want to see cards with specific tags. 0 = exclude, 1 = neutral, higher = prefer more. ", -1)),
						j(d, {
							modelValue: e.tagToAdd,
							"onUpdate:modelValue": [t[0] || (t[0] = (t) => e.tagToAdd = t), e.addTag],
							items: e.availableTagsToAdd,
							"item-title": "name",
							"item-value": "name",
							label: "Add tag preference",
							placeholder: "Search tags...",
							density: "compact",
							variant: "outlined",
							clearable: "",
							"hide-details": "",
							class: "mb-4"
						}, {
							item: W(({ props: e, item: t }) => [j(u, ae(ie(e)), {
								subtitle: W(() => [A(H(t.raw.snippet), 1)]),
								_: 2
							}, 1040)]),
							_: 1
						}, 8, [
							"modelValue",
							"items",
							"onUpdate:modelValue"
						]),
						e.tagNames.length > 0 ? (L(), E(h, {
							key: 0,
							class: "mt-4"
						}, {
							default: W(() => [(L(!0), O(C, null, z(e.tagNames, (t) => (L(), E(u, {
								key: t,
								class: "px-0"
							}, {
								default: W(() => [k("div", hr, [
									j(f, {
										size: "small",
										variant: "tonal",
										class: "flex-shrink-0",
										style: { "min-width": "120px" }
									}, {
										default: W(() => [A(H(t), 1)]),
										_: 2
									}, 1024),
									j(p, {
										"model-value": e.preferences.boost[t],
										min: e.sliderConfigResolved.min,
										max: e.globalSliderMax,
										step: .01,
										"hide-details": "",
										class: "flex-grow-1",
										"thumb-label": "",
										"onUpdate:modelValue": (n) => e.updateBoost(t, n)
									}, {
										"thumb-label": W(({ modelValue: t }) => [A(H(e.formatMultiplier(t)), 1)]),
										_: 2
									}, 1032, [
										"model-value",
										"min",
										"max",
										"onUpdate:modelValue"
									]),
									k("span", gr, H(e.formatMultiplier(e.preferences.boost[t])), 1),
									j(m, {
										icon: "mdi-plus",
										size: "small",
										variant: "text",
										density: "compact",
										disabled: e.globalSliderMax >= e.sliderConfigResolved.absoluteMax,
										onClick: (n) => e.expandSliderRange(t)
									}, null, 8, ["disabled", "onClick"]),
									j(m, {
										icon: "mdi-delete",
										size: "small",
										variant: "text",
										density: "compact",
										onClick: (n) => e.removeTag(t)
									}, null, 8, ["onClick"])
								])]),
								_: 2
							}, 1024))), 128))]),
							_: 1
						})) : (L(), E(l, {
							key: 1,
							type: "info",
							variant: "tonal",
							class: "mt-4"
						}, {
							default: W(() => t[9] || (t[9] = [A(" No tag preferences configured yet. Add tags above to get started. ")])),
							_: 1
						}))
					]),
					e.saveError ? (L(), E(l, {
						key: 0,
						type: "error",
						variant: "tonal",
						class: "mt-4",
						closable: "",
						"onClick:close": t[1] || (t[1] = (t) => e.saveError = "")
					}, {
						default: W(() => [A(H(e.saveError), 1)]),
						_: 1
					})) : D("", !0),
					e.saveSuccess ? (L(), E(l, {
						key: 1,
						type: "success",
						variant: "tonal",
						class: "mt-4",
						closable: "",
						"onClick:close": t[2] || (t[2] = (t) => e.saveSuccess = !1)
					}, {
						default: W(() => t[11] || (t[11] = [A(" Preferences saved successfully ")])),
						_: 1
					})) : D("", !0)
				])) : (L(), E(l, {
					key: 0,
					type: "info",
					variant: "tonal",
					class: "mb-4"
				}, {
					default: W(() => t[6] || (t[6] = [A(" Select a course to configure your learning preferences. ")])),
					_: 1
				}))]),
				_: 1
			}),
			e.courseId && !e.loading ? (L(), E(y, { key: 1 }, {
				default: W(() => [
					j(v),
					j(m, {
						variant: "text",
						disabled: !e.hasChanges,
						onClick: e.resetToSaved
					}, {
						default: W(() => t[12] || (t[12] = [A(" Reset ")])),
						_: 1
					}, 8, ["disabled", "onClick"]),
					j(m, {
						color: "primary",
						variant: "flat",
						loading: e.saving,
						disabled: !e.hasChanges,
						onClick: e.savePreferences
					}, {
						default: W(() => t[13] || (t[13] = [A(" Save Preferences ")])),
						_: 1
					}, 8, [
						"loading",
						"disabled",
						"onClick"
					])
				]),
				_: 1
			})) : D("", !0)
		]),
		_: 1
	}, 8, ["loading"]);
}
var vr = /* @__PURE__ */ r(dr, [["render", _sfc_render], ["__scopeId", "data-v-8fb14605"]]);
//#endregion
export { a as AudioAutoPlayer, nr as CardBrowser, at as CardHistoryViewer, un as CardLoader, Ke as CardSearch, Qe as CardSearchResults, Q as CardViewer, f as CodeBlockRenderer, Kn as CourseCardBrowser, $n as CourseInformation, lr as CourseTagFilterWidget, Displayable, m as FillInInput, Ae as HeatMap, y as MarkdownRenderer, _ as MdTokenRenderer, $t as MultipleChoiceOption, Ue as PaginatingToolbar, Question, nn as RadioMultipleChoice, yn as RequestPasswordReset, Nn as ResetPassword, Bt as SessionControllerDebug, Ne as SkMouseTrap, Fe as SkMouseTrapToolTip, e as SkldrMouseTrap, Be as SnackbarService, Zt as StudySession, st as StudySessionTimer, on as TFSelect, Rn as TagsInput, dn as UserChip, cn as UserInputNumber, d as UserInputString, mn as UserLogin, Cn as UserLoginAndRegistrationContainer, gn as UserRegistration, vr as UserTagPreferences, An as VerifyEmail, Z as alertUser, h as containsComponent, getCurrentUser, getUserStatus, v as isComponent, isDefineComponent, s as isInlineComponent, isPasswordValid, o as isQuestionView, p as parseComponentSyntax, b as parseComponentToken, te as piniaPlugin, requestPasswordReset, resetPassword, sendVerificationEmail, c as splitByDelimiters, l as splitParagraphToken, g as splitTextToken, useAuthStore, i as useCardPreviewModeStore, useConfigStore, useEntitlements, ee as useQuestionView, n as useViewable, validatePassword, verifyEmail };

//# sourceMappingURL=common-ui.es.js.map